<!-- =========================================================================================
  File Name: Profile.vue
  Description: Profile Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div>
    <!-- document tasks -->

    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div class="confhub book-modal">
        <div class="preview-doc">
          <div class="preview">
            <vs-popup title="Preview" class="confirmPopup" :active.sync="preview">
              <div v-if="previewLinks[image]" class="w-full p-5 text-center">
                <img
                  v-if="!image.includes('.pdf')"
                  :src="previewLinks[image]"
                  class="img-responsive"
                  height="200"
                />
                <iframe
                  v-else
                  class="w-100 custom-image-class"
                  :src="previewLinks[image]"
                  height="200"
                  style="border: none"
                />
              </div>
              <div v-else class="w-full p-5 text-center">
                <DropFileForm @selectedFile="selectedFile" />
              </div>

              <div class="w-full text-center">
                <b-button size="md" @click="selectedImage1" variant="primary">
                  {{ $t("Select") }}
                </b-button>
              </div>
            </vs-popup>
          </div>
        </div>
        <b-card class="mt-2">
          <div v-if="!errorMsg && companyDetails" id="profile-page">
            <!-- PROFILE HEADER -->
            <div class="profile-header company-details">
              <div class="relative">
                <div class="pointer-events">
                  <div>
                    <b-avatar
                      v-if="profile_image != 'loading'"
                      button
                      variant="light"
                      @click="redirectToWebsiteUrl"
                      :class="
                        (!header && profile_image == null) ||
                        (header && profile_image == null) ||
                        (!header && profile_image != null)
                          ? 'avatar-default'
                          : ''
                      "
                      class="user-profile-img img-center"
                      :src="header && profile_image ? profile_image : defaults"
                      size="85px"
                    ></b-avatar>
                  </div>
                </div>
                <div class="company-center mt-5">
                  <h4>{{ company.company_name }}</h4>
                </div>
                <div class="company-welcome-msg mt-5">
                  <p class="ql-editor" v-html="company.welcome_message"></p>
                </div>
              </div>

              <div class="departments mt-5">
                <div class="vx-row sm:flex-row lg:flex-row">
                  <div
                    v-for="(dep, index) in company.departments"
                    :key="index"
                    :class="{ 'lg:w-1/2 xl:w-1/2': departmentCount > 1 }"
                    class="department-card vx-col w-full md:w-full sm:w-full flex flex-col justify-between mt-10"
                  >
                    <a @click="selectDpt(dep.id)" style="cursor: pointer">
                      <div class="department-list mt-2 ml-5 mr-5 mb-10">
                        <div class="department-header">
                          <div class="marker" :style="buttonCss"></div>
                          <div class="department-name">
                            <span style="color: #2c2c2c">{{ dep.department_name }}</span>
                          </div>
                          <div class="arrow"></div>
                        </div>
                        <div
                          class="department-desc ql-editor"
                          v-html="dep.description"
                        ></div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!errorMsg && !showConfirmation && !companyDetails"
            id="profile-page"
            class="time-selection"
          >
            <div class="vx-row sm:flex-row lg:flex-row">
              <div
                :class="
                  'vx-col w-full md:w-full sm:w-full flex flex-col justify-between details ' +
                  col
                "
              >
                <div class="relative">
                  <b-button
                    :style="buttonCss"
                    variant="primary"
                    class="booking-form-btn"
                    @click="back"
                    v-if="hide"
                  >
                    <b-icon
                      icon="arrow-left"
                      variant="white"
                      :style="'color:' + buttonCss.color + ' !important'"
                    ></b-icon
                  ></b-button>
                  <div class="pointer-event mt-10 center text-center">
                    <div>
                      <b-avatar
                        v-if="profile_image != 'loading'"
                        button
                        variant="light"
                        @click="redirectToWebsiteUrl"
                        :class="
                          (!header && profile_image == null) ||
                          (header && profile_image == null) ||
                          (!header && profile_image != null)
                            ? 'avatar-default'
                            : ''
                        "
                        class="user-profile-img img-center"
                        :src="header && profile_image ? profile_image : defaults"
                        size="85px"
                      ></b-avatar>
                    </div>
                  </div>
                  <div class="company-center mt-2 ml-1 center">
                    <p class="text-center companyName" :style="textColor">
                      {{ department.company_name }}
                    </p>
                    <h3
                      class="mt-2"
                      :style="{
                        fontSize: font_size.title + 'px',
                        ...textColor,
                      }"
                    >
                      {{ department.department_name }}
                    </h3>
                  </div>
                  <div class="dept-desc" :style="textColor">
                    <p class="mt-5">
                      <i class="feather icon-clock"></i>
                      <b> {{ $t("Open") }}: </b>
                      <span class="custome-text-color">{{
                        department.company_opening_hours
                      }}</span>
                    </p>
                    <p class="mt-1">
                      <i class="feather icon-phone-call"></i>
                      <b> {{ $t("Forenquiry") }}: </b>
                      <span class="custome-text-color">{{
                        department.company_contact
                      }}</span>
                    </p>

                    <p
                      v-if="showConfirm"
                      class="date-time mt-3 custome-text-color"
                      style="text-transform: capitalize"
                    >
                      <span :style="textColor">
                        <i class="feather icon-calendar"></i>
                        {{ selectedTime.start_time }} - {{ selectedTime.end_time }},
                        {{ slectedDate }}
                      </span>
                    </p>
                    <div class="book">
                      <p
                        class="mt-5 text-justify ql-editor"
                        :style="{
                          fontSize: font_size.paragraph + 'px',
                          ...textColor,
                        }"
                        v-html="department.booking_message"
                      ></p>
                    </div>
                    <div class="vx-row ml-1" v-if="cancel">
                      <b-button
                        id="cancel-meeting"
                        size="lg"
                        class="btn-custom-color"
                        @click="cancelMeeting"
                        >{{ $t("CancelMeeting") }}</b-button
                      >
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div
                v-if="!showConfirm"
                :class="
                  'custom-margin-auto vx-col w-full md:w-1/2 sm:w-1/2 flex flex-col justify-between calender ' +
                  col
                "
              >
                <div v-if="walkinEnabled" :style="textColor">
                  <h4 :style="textColor">{{ $t("WalkInMeeting") }}</h4>
                  <div class="flex items-center py-5">
                    <span class="rounded"
                      ><div class="h-5 w-5 rounded-full mr-2" :class="'bg-success'"></div
                    ></span>
                    <strong>{{ $t("WalkMessage") }}</strong>
                  </div>

                  <div class="vx-row align-center">
                    <b-button
                      id="start-meeting"
                      size="lg"
                      class="btn-custom-color"
                      @click="confirmMeeting()"
                      >{{ $t("StartTheMeeting") }}</b-button
                    >
                  </div>
                  <hr
                    style="width: 50px; margin-left: 46%"
                    align="center"
                    class="align-center mt-10"
                  />
                </div>

                <div class="relative">
                  <br />
                  <h4 class="text-center" :style="textColor">
                    {{
                      !department.is_physical_appointment && startMeeting.available_staffs
                        ? $t("SelectDataTime1")
                        : $t("SelectDataTime")
                    }}
                  </h4>
                  <div class="mt-2">
                    <functional-calendar
                      v-model="calendarData"
                      :limits="{ min: currentDate, max: endDate }"
                      :newCurrentDate="new Date(firstDay)"
                      :is-date-picker="true"
                      :markedDates="slots_availablity"
                      :disabledDates="disabledDates"
                      @dayClicked="getTimeSlots"
                      :hidden-elements="['leftAndRightDays']"
                      :isLayoutExpandable="true"
                      :dayNames="days"
                      :monthNames="months"
                      v-if="showCalender"
                      v-on:changedMonth="changedMonth"
                    ></functional-calendar>
                  </div>
                  <div v-if="slotMsg" class="mt-5 ml-10" style="color: red">
                    {{ $t("TimeSlotNotAvailable") }}
                  </div>
                </div>
                <div class="vx-row">
                  <!-- required -->
                  <!-- Must be a valid email -->
                  <div class="vx-col w-full" v-if="showTimeSlots">
                    <div class="control_wrapper">
                      <ejs-dropdownlist
                        id="dropdownlist"
                        class="mt-1 w-full contact_number"
                        v-validate="'required'"
                        v-model="timeZone"
                        label="timezone"
                        name="is_premium"
                        :allowFiltering="allowFiltering"
                        :dataSource="options"
                        :data-vv-as="$t('TimeZone')"
                        :placeholder="$t('SelectTimeZone')"
                        :fields="fields"
                        @change="timezoneChanged($event.value)"
                      ></ejs-dropdownlist>
                    </div>
                    <span
                      class="text-danger text-sm"
                      :style="textColor"
                      v-show="errors.has('is_premium')"
                      >{{ errors.first("is_premium") }}</span
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="showTimeSlots"
                :class="
                  'vx-col w-full md:w-1/2 sm:w-1/2 flex flex-col justify-between timeslot ' +
                  col
                "
              >
                <b-button class="back-btn" variant="primary" @click="backToCalender">
                  <b-icon icon="arrow-left" variant="white"></b-icon
                ></b-button>
                <div class="relative mt-20">
                  <h5 class="mb-5" style="text-transform: capitalize">
                    <span :style="textColor" v-if="selectedDate">{{ selectedDate }}</span>
                  </h5>
                  <div :class="slots.length > 5 ? 'scroll' : ''">
                    <div
                      id="slot-list"
                      class="slot-list"
                      v-for="(slot, index) in slots"
                      :key="index"
                    >
                      <!-- :id="'time-button-' + index" -->
                      <!-- :class="checkSlots(index) ? 'isActive' : ''" -->
                      <b-button
                        variant="border"
                        class="time-button"
                        type="button"
                        :class="{ isActive: slot.isActive }"
                        @click.prevent="timeSlotSelected(index)"
                        >{{ slot.start_time }}</b-button
                      >
                      <!-- :id="'confirm-button-' + index" -->
                      <b-button
                        v-if="slot.isActive"
                        variant="border"
                        class="confirm-button booking-form-btn"
                        type="button"
                        @click="confirm(slot, index)"
                        :style="buttonCss"
                        >{{ $t("Confirm") }}</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showConfirm"
                :class="
                  'vx-col w-full md:w-full sm:w-full flex flex-col justify-between info ' +
                  col
                "
              >
                <div class="relative">
                  <br />
                  <div v-if="!showLoginForm" class="details-form">
                    <h6 :style="textColor">
                      <template v-if="formLength > 0">{{ $t("EnterDetails") }}</template>
                      <span v-if="!scheduleEvent.id">
                        ({{ $t("AccountText") }}
                        <a
                          @click="showLoginForm = true"
                          style="cursor: pointer"
                          class="text-primary"
                          >{{ $t("Login") }}</a
                        >)
                      </span>
                    </h6>
                    <form id="schedule" data-vv-scope="schedule" v-if="!multi_form">
                      <div
                        class="vx-row"
                        v-for="(field, index, loopCount) in formFields"
                        :key="index"
                      >
                        <div
                          class="vx-col md:w-full w-full mt-4"
                          v-if="field.shown && field.type == 'input'"
                        >
                          <label :style="textColor" class="vs-input--label">{{
                            $t(field.label != undefined ? field.label : $t(index))
                          }}</label>
                          <vue-tags-input
                            v-if="index === 'guest_emails'"
                            v-model="scheduleEvent[index]"
                            class="w-full"
                            @tags-changed="(newTags) => (guestEmails = newTags)"
                            :validation="guestEmailValidations"
                            :tags="guestEmails"
                            :placeholder="$t('AddGuestEmailsPlaceholder')"
                            :add-on-key="['Tab', ',']"
                          >
                          </vue-tags-input>
                          <b-form-input
                            :autofocus="loopCount == 0"
                            v-else
                            size="lg"
                            v-validate="{
                              required: field.required,
                              email: index == 'email' ? true : false,
                              max:
                                index == 'age'
                                  ? 2
                                  : index == 'first_name' || index == 'last_name'
                                  ? 20
                                  : false,
                              min_value: index == 'age' ? 1 : false,
                            }"
                            :name="field.label != undefined ? field.label : index"
                            :data-vv-as="
                              $t(field.label != undefined ? field.label : index)
                            "
                            v-model="scheduleEvent[index]"
                            class="w-full"
                            :disabled="
                              index == 'email'
                                ? scheduleEvent['id']
                                  ? true
                                  : false
                                : false
                            "
                            :type="index == 'age' ? 'number' : 'text'"
                          ></b-form-input>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="
                              errors.has(
                                'schedule.' +
                                  (field.label != undefined ? field.label : index)
                              )
                            "
                            >{{
                              errors.first(
                                "schedule." +
                                  (field.label != undefined ? field.label : index)
                              )
                            }}</span
                          >
                        </div>
                        <div
                          class="vx-col md:w-full w-full mt-8"
                          v-if="field.shown && field.type == 'contact'"
                        >
                          <label :style="textColor" class="contact_number_label">{{
                            $t(index)
                          }}</label>
                          <!--
                      <span v-if="field.required">*</span> -->
                          <vue-tel-input
                            :autofocus="loopCount == 0"
                            size="large"
                            v-validate="{
                              required: field.required,
                              regex: /^(?=.*[0-9])[- +()0-9]+$/,
                              min: 12,
                            }"
                            v-model="scheduleEvent[index]"
                            class="w-full contact_number"
                            v-on:country-changed="countryChanged"
                            v-bind="bindProps"
                            @onInput="onInput"
                            v-on:blur="appendCode"
                            :data-vv-as="$t(index)"
                          ></vue-tel-input>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('schedule.' + index)"
                            >{{ errors.first("schedule." + index) }}</span
                          >
                        </div>
                        <div
                          class="vx-col md:w-full w-full mt-8"
                          v-if="field.shown && field.type == 'select'"
                        >
                          <label :style="textColor">{{ $t(index) }}</label>
                          <!-- <span v-if="field.required">*</span>  -->
                          <v-select
                            :autofocus="loopCount == 0"
                            class="mt-1 w-full"
                            v-validate="{ required: field.required }"
                            v-model="scheduleEvent[index]"
                            :options="genderArray"
                            :name="field.label != undefined ? field.label : index"
                            :data-vv-as="$t(index)"
                            :placeholder="$t('Select') + $t(index).toLowerCase()"
                          >
                            <template v-slot:option="option">
                              <span :class="option.icon">{{ option.label }} </span>
                              <feather-icon
                                v-if="
                                  scheduleEvent[index] &&
                                  scheduleEvent[index] == option.label
                                "
                                icon="CheckIcon"
                                class="float-right"
                                svgClasses="w-5 h-5"
                              />
                            </template>
                          </v-select>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('schedule.' + index)"
                            >{{ errors.first("schedule." + index) }}</span
                          >
                        </div>

                        <div
                          class="vx-col md:w-full w-full mt-8"
                          v-if="field.shown && field.type == 'calender'"
                        >
                          <label :style="textColor" class="contact_number_label">{{
                            $t(index)
                          }}</label>
                          <!-- <span v-if="field.required">*</span>  -->

                          <b-form-datepicker
                            :placeholder="$t('Select') + $t(index).toLowerCase()"
                            v-model="scheduleEvent[index]"
                            v-validate="{ required: field.required }"
                            :format="format"
                            :disabled-dates="state.disabledDates"
                            :name="'schedule.' + index"
                            :data-vv-as="$t(index)"
                            class="p-1 datepick"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }"
                            :show-decade-nav="showDecadeNav"
                            :hide-header="hideHeader"
                          ></b-form-datepicker>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('schedule.' + index)"
                            >{{ errors.first("schedule." + index) }}</span
                          >
                        </div>

                        <div
                          class="vx-col md:w-1/2 w-full mt-8"
                          v-if="field.shown && field.type == 'file'"
                        >
                          <label :style="textColor">{{ $t(index) }}</label>
                          <!-- <span v-if="field.required">*</span>  -->
                          <v-select
                            class="mt-1 w-full"
                            v-validate="{ required: field.required }"
                            v-model="scheduleEvent['type']"
                            :options="documentTypeArray"
                            :name="field.label != undefined ? field.label : index"
                            :data-vv-as="$t(index)"
                            :placeholder="$t('Select') + $t(index).toLowerCase()"
                          >
                            <template v-slot:option="option">
                              <span :class="option.icon">{{ option.label }} </span>
                              <feather-icon
                                v-if="
                                  scheduleEvent['type'] &&
                                  scheduleEvent['type'].code == option.code
                                "
                                icon="CheckIcon"
                                class="float-right"
                                svgClasses="w-5 h-5"
                              />
                            </template>
                          </v-select>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('schedule.' + index)"
                            >{{ errors.first("schedule." + index) }}</span
                          >
                        </div>

                        <!-- =================== -->
                        <div
                          class="vx-col md:w-1/2 w-full mt-8"
                          v-if="field.shown && field.type == 'file'"
                        >
                          <label :style="textColor">{{
                            $t("Upload") + " " + $t("document").toLowerCase()
                          }}</label>
                          <span v-if="field.required">*</span>
                          <span class="clearfix"></span>
                          <img
                            :src="url"
                            class="mr-8 rounded mt-1"
                            width="85px"
                            @error="errorImage"
                          />

                          <b-button
                            v-if="loginUser"
                            variant="primary"
                            class="mr-4 mb-4 mt-2 booking-form-btn"
                            size="lg"
                            :style="buttonCss"
                            @click="$bvModal.show(`schedule.${index}`)"
                            >{{ $t("Upload") }}</b-button
                          >
                          <b-button
                            v-else
                            variant="primary"
                            class="mr-4 mb-4 mt-2 booking-form-btn"
                            size="lg"
                            :style="buttonCss"
                            @click="preview = true"
                            >{{ $t("Upload") }}</b-button
                          >
                          <br />

                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('schedule.' + 'uploadDocument')"
                            >{{ errors.first("schedule." + "uploadDocument") }}</span
                          >
                        </div>

                        <b-modal
                          :title="$t('Documents')"
                          :id="`schedule.${index}`"
                          class="book-modal-documents"
                        >
                          <!-- <template #modal-header="{ close }">

    </template> -->

                          <template #default="{ hide }">
                            <div class="docList">
                              <div class="vx-row" v-if="userDocs.length > 0">
                                <div
                                  v-for="(image, count) in userDocs"
                                  :key="count"
                                  @click="
                                    selectedImage(image.answer, `schedule.${index}`)
                                  "
                                >
                                  <img
                                    v-if="!image.answer.includes('.pdf')"
                                    :src="previewLinks[image.answer]"
                                    alt="Preview"
                                    width="150"
                                    height="150"
                                    class="img-resposive p-2"
                                  />
                                  <img
                                    v-else
                                    class="custom-image-class"
                                    :src="defaultDoc"
                                    width="150"
                                    height="150"
                                    style="border: none"
                                  />
                                </div>
                              </div>
                              <div class="vx-row" v-else>
                                <div class="w-full text-center p-5">
                                  <h3>{{ $t("NoDocuments") }}</h3>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="text-center">
            <label for="">No documents saved.</label>
          </div> -->
                          </template>

                          <template #modal-footer="{ ok }">
                            <div class="w-full text-center">
                              <b-button
                                variant="primary"
                                class="mr-4 mb-4 mt-2"
                                size="lg"
                                :style="buttonCss"
                                @click="
                                  $bvModal.hide(`schedule.${index}`);
                                  preview = true;
                                "
                                >{{ $t("Upload") }}</b-button
                              >
                              <br />
                            </div>

                            <!-- Emulate built in modal footer ok and cancel button actions -->
                          </template>
                        </b-modal>

                        <!-- ==================== -->
                      </div>

                      <br />
                      <div
                        class="vx-row"
                        v-for="(field, index) in questionsFields"
                        :key="index"
                      >
                        <!-- {{field}} -->
                        <div
                          class="vx-col md:w-full w-full mt-1"
                          v-if="field.shown && field.type == 'input'"
                        >
                          <label :style="textColor" class="vs-input--label">{{
                            $t(field.label != undefined ? field.label : $t(index))
                          }}</label>
                          <b-form-input
                            size="lg"
                            v-validate="{
                              required: field.required,
                            }"
                            :name="field.label != undefined ? field.label : index"
                            :data-vv-as="
                              $t(field.label != undefined ? field.label : index)
                            "
                            v-model="selectedInput[index]"
                            class="w-full"
                            :type="'text'"
                          ></b-form-input>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="
                              errors.has(
                                'schedule.' +
                                  (field.label != undefined ? field.label : index)
                              )
                            "
                            >{{
                              errors.first(
                                "schedule." +
                                  (field.label != undefined ? field.label : index)
                              )
                            }}</span
                          >
                        </div>

                        <div
                          class="vx-col md:w-full w-full mt-5"
                          v-if="field.shown && field.type == 'text-area'"
                        >
                          <label :style="textColor" class="vs-input--label">{{
                            $t(field.label != undefined ? field.label : $t(index))
                          }}</label>
                          <b-form-textarea
                            size="lg"
                            v-validate="{
                              required: field.required,
                            }"
                            :name="field.label != undefined ? field.label : index"
                            :data-vv-as="
                              $t(field.label != undefined ? field.label : index)
                            "
                            v-model="selectedInput[index]"
                            class="w-full"
                          ></b-form-textarea>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="
                              errors.has(
                                'schedule.' +
                                  (field.label != undefined ? field.label : index)
                              )
                            "
                            >{{
                              errors.first(
                                "schedule." +
                                  (field.label != undefined ? field.label : index)
                              )
                            }}</span
                          >
                        </div>

                        <div
                          class="vx-col md:w-full w-full mt-5"
                          :style="textColor"
                          v-if="field.shown && field.type == 'checkbox'"
                        >
                          <!-- <div v-for="(item, index1) in field" :key="index1">
  <input type="checkbox" :id="item" v-model="selectedInput[index]" :value="item">
  <label :for="item">{{ item }} </label>
  </div> -->
                          <b-form-group :label="field.label" v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group
                              v-model="selectedInput[index]"
                              :options="field.option_questions"
                              :aria-describedby="ariaDescribedby"
                              :name="'check' + index"
                              @click="checkValidation(selectedInput[index], index)"
                              stacked
                            ></b-form-checkbox-group>
                          </b-form-group>
                          <div v-if="checkValidation(selectedInput[index], index)">
                            <span
                              class="text-danger text-sm"
                              :style="textColor"
                              v-if="field.required"
                              >At least one answer must be checked</span
                            >
                          </div>
                          <div :id="'input' + index" class="hide-check">
                            <span
                              class="text-danger text-sm"
                              :style="textColor"
                              v-if="field.required"
                              >At least one answer must be checked</span
                            >
                          </div>
                          <!-- <div>
                            <span
                              class="text-danger text-sm"
                              v-show="
                                errors.has(
                                  'schedule.' +
                                    (field.label != undefined
                                      ? field.label
                                      : index)
                                )
                              "
                              >{{
                                errors.first(
                                  "schedule." +
                                    (field.label != undefined
                                      ? field.label
                                      : index)
                                )
                              }}</span
                            >
                          </div> -->
                        </div>
                        <!-- checkbox -->
                        <!-- radio -->
                        <div
                          class="vx-col md:w-full w-full mt-5"
                          v-if="field.shown && field.type == 'radio'"
                        >
                          <h6 :style="textColor">
                            {{ $t(field.label != undefined ? field.label : $t(index)) }}
                          </h6>
                          <!-- <b-form-group
                            :label="

                            "
                            v-slot="{ ariaDescribedby }"
                          >
                            <b-form-radio-group
                               v-validate="{ required: field.required }"
                              :id="'option' + field.id"
                              v-model="selectedInput[index]"
                              :options="field.option_questions"
                              :aria-describedby="ariaDescribedby"
                              :name="'option' + field.id"
                              plain
                              stacked
                            ></b-form-radio-group>
                          </b-form-group> -->
                          <div class="mt-2">
                            <b-form-group v-slot="{ ariaDescribedby }">
                              <b-form-radio
                                :key="option"
                                v-for="option in field.option_questions"
                                v-model="selectedInput[index]"
                                :aria-describedby="ariaDescribedby"
                                :name="'option' + field.id"
                                :value="option"
                                >{{ option }}</b-form-radio
                              >
                              <!-- <b-form-radio-group
                                v-validate="{ required: field.required }"
                                id="radio-group-1"
                                v-model="selectedInput[index]"
                                :options="field.option_questions"
                                :aria-describedby="ariaDescribedby"
                                :name="'option' + field.id"
                              ></b-form-radio-group> -->
                            </b-form-group>

                            <!-- <label
                              :style="textColor"
                              class="radio flex"
                              v-for="(option, index3) in field.option_questions"
                              :key="index3"
                            >

                              <input
                                type="radio"
                                :value="option"
                                v-model="selectedInput[index]"
                                class="radio-input"
                                v-validate="'required'"
                                :name="
                                  field.label != undefined ? field.label : index
                                "
                                :id="
                                  field.label != undefined ? field.label : index
                                "
                              />
                              <span class="radio-label ml-3">{{ option }}</span>
                              <br />
                            </label> -->
                          </div>

                          <div>
                            <span
                              class="text-danger text-sm"
                              :style="textColor"
                              v-show="
                                errors.has(
                                  'schedule.' +
                                    (field.label != undefined ? field.label : index)
                                )
                              "
                              >{{
                                errors.first(
                                  "schedule." +
                                    (field.label != undefined ? field.label : index)
                                )
                              }}</span
                            >
                          </div>
                        </div>
                        <!-- =================== -->
                        <div
                          class="vx-col w-full mt-3"
                          v-if="field.shown && field.type == 'files'"
                        >
                          <h4>
                            {{ $t(field.label != undefined ? field.label : $t(index))
                            }}<span :style="textColor" v-if="field.required">*</span>
                          </h4>
                          <div
                            v-for="(file, index3) in field.option_questions"
                            :key="index3"
                            class="w-8/12"
                          >
                            <label class="w-full mb-1"
                              >{{ file }}
                              <span :style="textColor" v-if="field.required">*</span>
                            </label>

                            <template
                              v-if="
                                selectedInput[index] &&
                                selectedInput[index][file] &&
                                isFile(selectedInput[index][file])
                              "
                            >
                              <span class="w-10/12 text-info">
                                {{ selectedInput[index][file].name }}
                              </span>
                              <a
                                class="w-2/12 text-danger"
                                @click.prevent="unsetFile(index, file)"
                                title="Remove"
                              >
                                <feather-icon
                                  icon="XIcon"
                                  class="float-right"
                                  svgClasses="h-5"
                                />
                              </a>
                            </template>

                            <template v-else>
                              <input
                                :ref="file"
                                type="file"
                                v-validate="{
                                  required: field.required,
                                  size: 5048,
                                }"
                                class="hidden"
                                :name="`${file}-${index}`"
                                accept="image/*, application/pdf,doc, pdf, xls, jpg, png, ppt"
                                :data-vv-as="$t('documents')"
                                @change="setFiles(index, file, $event)"
                              />
                              <!-- $bvModal.show(`${file}`) -->
                              <img
                                v-if="loginUser"
                                @click="openModal(`${file}-${index}`)"
                                :src="defaultImg"
                                class="ml-5 mr-5 rounded mt-1"
                                width="32px"
                              />
                              <img
                                v-else
                                @click="$refs[file][0].click()"
                                :src="defaultImg"
                                class="ml-5 mr-5 rounded mt-1"
                                width="32px"
                              />

                              <b-button
                                v-if="loginUser"
                                variant="primary"
                                class="mr-4 mb-4 mt-2 booking-form-btn"
                                size="md"
                                :style="buttonCss"
                                @click="openModal(`${file}-${index}`)"
                                >{{ $t("Upload") }}</b-button
                              >
                              <b-button
                                v-else
                                variant="primary"
                                class="mr-4 mb-4 mt-2 booking-form-btn"
                                size="md"
                                :style="buttonCss"
                                @click="$set(preview1, index3, true)"
                                >{{ $t("Upload") }}</b-button
                              >

                              <b-modal
                                :title="$t('Documents')"
                                :id="`${file}-${index}`"
                                class="book-modal-documents"
                              >
                                <!-- <template #modal-header="{ close }">

    </template> -->

                                <template #default="{ hide }">
                                  <div class="">
                                    <div class="vx-row" v-if="userDocs.length > 0">
                                      <div
                                        v-for="(image, count) in userDocs"
                                        :key="count"
                                        @click="
                                          selectedImageMultiple(
                                            image.answer,
                                            `${file}-${index}`,
                                            index3
                                          )
                                        "
                                      >
                                        <img
                                          v-if="!image.answer.includes('.pdf')"
                                          :src="previewLinks[image.answer]"
                                          alt="Preview"
                                          width="150"
                                          height="150"
                                          class="img-resposive p-2"
                                        />
                                        <img
                                          v-else
                                          class="custom-image-class"
                                          :src="defaultDoc"
                                          width="150"
                                          height="150"
                                          style="border: none"
                                        />
                                      </div>
                                    </div>
                                    <div class="vx-row" v-else>
                                      <div class="w-full text-center p-5">
                                        <h3>{{ $t("NoDocuments") }}</h3>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="text-center">
            <label for="">No documents saved.</label>
          </div> -->
                                </template>

                                <template #modal-footer="{ ok }">
                                  <div class="w-full text-center">
                                    <input
                                      :ref="file"
                                      type="file"
                                      v-validate="{
                                        required: field.required,
                                        size: 5048,
                                      }"
                                      class="hidden"
                                      :name="`${file}`"
                                      accept="image/*, application/pdf,doc, pdf, xls, jpg, png, ppt"
                                      :data-vv-as="$t('documents')"
                                      @change="setFiles(index, file, $event)"
                                    />

                                    <img
                                      @click="$refs[file][0].click()"
                                      :src="defaultImg"
                                      class="ml-5 mr-5 rounded mt-1"
                                      width="32px"
                                      v-show="false"
                                    />
                                    <b-button
                                      variant="primary"
                                      class="mr-4 mb-4 mt-2"
                                      size="md"
                                      :style="buttonCss"
                                      @click="
                                        $bvModal.hide(`${file}-${index}`);
                                        $set(preview1, index3, true);
                                        image = '';
                                      "
                                      >{{ $t("Upload") }}</b-button
                                    >
                                  </div>

                                  <!-- Emulate built in modal footer ok and cancel button actions -->
                                </template>
                              </b-modal>
                              <vs-popup
                                :title="`Preview-${index3}`"
                                class="confirmPopup"
                                :active.sync="preview1[index3]"
                              >
                                <!-- Fine Footer -->
                                <!-- Modale conferma di prenotazione -->

                                <div
                                  v-if="previewLinks[image]"
                                  class="w-full p-5 text-center"
                                >
                                  <img
                                    v-if="!image.includes('.pdf')"
                                    :src="previewLinks[image]"
                                    class="img-responsive"
                                    height="200"
                                  />
                                  <iframe
                                    v-else
                                    class="w-100 custom-image-class"
                                    :src="previewLinks[image]"
                                    height="200"
                                    style="border: none"
                                  />
                                </div>
                                <div v-else class="w-full p-5 text-center">
                                  <DropFileForm
                                    @selectedFile="setFiles"
                                    :idx="index"
                                    :labelFile="file"
                                  />
                                </div>

                                <div class="w-full text-center">
                                  <b-button
                                    size="md"
                                    @click="selectedImage2(index, file, image, index3)"
                                    variant="primary"
                                  >
                                    {{ $t("Select") }}
                                  </b-button>
                                  <!-- <b-button
                    variant="primary"
                    class="mr-4 mt-2 border-primary"
                    @click="$refs.file.click()"
                    >{{ $t("Change") }}</b-button
                  > -->
                                </div>
                              </vs-popup>
                            </template>

                            <!-- <span class="text-info" v-if="imageMultiple.length"> {{ imageMultiple.length }} files</span> -->
                            <br />
                            <!-- <div class="flex">

                                <div v-for="(image, key) in imageMultiple" :key="key">
                                  <img class="mr-8 rounded mt-1"
                                                        width="85px" :ref="'image'" />
                                          <br>

                                  <span class="text-info"> {{ image.name }}</span>
                                </div>

                              </div> -->
                            <span
                              v-if="errors.has(`schedule.${file}-${index}`)"
                              class="text-danger text-sm mb-1"
                              :style="textColor"
                            >
                              {{ errors.first(`schedule.${file}-${index}`) }}
                            </span>
                          </div>
                        </div>
                        <!-- form second -->
                      </div>
                      <div
                        class="vx-col"
                        :class="{ 'w-full': formLength < 1 }"
                        v-if="!showLoginForm"
                      >
                        <b-button
                          v-if="walkinEnabled || type != 'walkin'"
                          ref="schedule-event-btn"
                          variant="primary"
                          size="lg"
                          @click="schedule('schedule')"
                          class="mt-5"
                          :class="{
                            'w-full p-5 booking-form-btn': formLength < 1,
                            block: formLength > 0,
                          }"
                          :style="buttonCss"
                          >{{
                            type == "walkin" ? $t("StartMeeting") : $t("ScheduleEvent")
                          }}
                        </b-button>
                      </div>
                    </form>

                    <form
                      @submit.prevent.stop
                      id="schedule"
                      data-vv-scope="schedule"
                      v-else
                    >
                      <div class="multi-form">
                        <template v-for="(field, index, key1) in formFieldsc1">
                          <div
                            v-if="currentIndex == key1"
                            class="vx-row multi-form-row"
                            :key="key1"
                            :data-index="index"
                            :data-key="key1"
                          >
                            <div
                              class="vx-col md:w-full w-full mt-5"
                              :style="textColor"
                              v-if="
                                field.shown &&
                                field.type == 'checkbox' &&
                                currentIndex == key1 &&
                                !field.form
                              "
                            >
                              <!-- <div v-for="(item, index1) in field" :key="index1">
    <input type="checkbox" :id="item" v-model="selectedInput[index]" :value="item">
    <label :for="item">{{ item }} </label>
    </div> -->
                              <label :style="textColor">{{
                                $t(field.label != undefined ? field.label : $t(index))
                              }}</label>
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-checkbox-group
                                  v-model="selectedInput[index]"
                                  :options="field.option_questions"
                                  :aria-describedby="ariaDescribedby"
                                  :name="index"
                                  v-validate="{
                                    required: field.required,
                                  }"
                                  class="check-box-font"
                                  @click="checkValidation(selectedInput[index], index)"
                                  stacked
                                ></b-form-checkbox-group>
                              </b-form-group>
                              <div>
                                <span
                                  v-if="errors.has(`schedule.${field.label}`)"
                                  class="text-danger text-sm"
                                  :style="textColor"
                                >
                                  {{ errors.first(`schedule.${field.label}`) }}
                                </span>
                              </div>
                              <!-- <div
                              v-if="checkValidation(selectedInput[index], index)"
                            >
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-if="field.required"
                                >At least one answer must be checked</span
                              >
                            </div>
                            <div :id="'input' + index" class="hide-check">
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-if="field.required"
                                >At least one answer must be checked</span
                              >
                            </div> -->
                            </div>
                            <div
                              class="vx-col md:w-full w-full mt-5"
                              v-if="
                                field.shown &&
                                field.type == 'text-area' &&
                                currentIndex == key1 &&
                                !field.form
                              "
                            >
                              <label :style="textColor" class="vs-input--label">{{
                                $t(field.label != undefined ? field.label : $t(index))
                              }}</label>
                              <b-form-textarea
                                size="lg"
                                v-validate="{
                                  required: field.required,
                                }"
                                :name="field.label != undefined ? field.label : index"
                                :data-vv-as="
                                  $t(field.label != undefined ? field.label : index)
                                "
                                v-model="selectedInput[index]"
                                class="w-full"
                              ></b-form-textarea>
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="
                                  errors.has(
                                    'schedule.' +
                                      (field.label != undefined ? field.label : index)
                                  )
                                "
                                >{{
                                  errors.first(
                                    "schedule." +
                                      (field.label != undefined ? field.label : index)
                                  )
                                }}</span
                              >
                            </div>

                            <!-- inout -->
                            <div
                              class="vx-col md:w-full w-full mt-4"
                              v-if="
                                field.shown &&
                                field.type == 'input' &&
                                currentIndex == key1 &&
                                !field.form
                              "
                            >
                              <label :style="textColor" class="vs-input--label">{{
                                $t(field.label != undefined ? field.label : $t(index))
                              }}</label>
                              <b-form-input
                                autofocus
                                size="lg"
                                v-validate="{
                                  required: field.required,
                                  email: index == 'email' ? true : false,
                                  max:
                                    index == 'age'
                                      ? 2
                                      : index == 'first_name' || index == 'last_name'
                                      ? 20
                                      : false,
                                  min_value: index == 'age' ? 1 : false,
                                }"
                                :name="field.label != undefined ? field.label : index"
                                :data-vv-as="
                                  $t(field.label != undefined ? field.label : index)
                                "
                                v-model="selectedInput[index]"
                                class="w-full"
                                :disabled="
                                  index == 'email'
                                    ? scheduleEvent['id']
                                      ? true
                                      : false
                                    : false
                                "
                                :type="index == 'age' ? 'number' : 'text'"
                              ></b-form-input>
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="
                                  errors.has(
                                    'schedule.' +
                                      (field.label != undefined ? field.label : index)
                                  )
                                "
                                >{{
                                  errors.first(
                                    "schedule." +
                                      (field.label != undefined ? field.label : index)
                                  )
                                }}</span
                              >
                            </div>
                            <!-- input -->
                            <!-- radio -->

                            <div
                              class="vx-col md:w-full w-full mt-5"
                              v-if="
                                field.shown &&
                                field.type == 'radio' &&
                                currentIndex == key1 &&
                                !field.form
                              "
                            >
                              <label :style="textColor">{{
                                $t(field.label != undefined ? field.label : $t(index))
                              }}</label>

                              <div class="mt-2">
                                <b-form-group v-slot="{ ariaDescribedby }">
                                  <b-form-radio
                                    v-validate="'required'"
                                    :key="option"
                                    v-for="option in field.option_questions"
                                    v-model="selectedInput[index]"
                                    :aria-describedby="ariaDescribedby"
                                    :name="'option' + field.id"
                                    :value="option"
                                    >{{ option }}</b-form-radio
                                  >
                                </b-form-group>
                                <!-- <h6
                                  :style="textColor"
                                  class="radio table-line"
                                  v-for="(
                                    option, index3
                                  ) in field.option_questions"
                                  :key="index3"
                                >

                                  <input
                                    autofocus
                                    type="radio"
                                    :value="option"
                                    v-model="selectedInput[index]"
                                    class="radio-input"
                                    v-validate="'required'"
                                    :name="
                                      field.label != undefined
                                        ? field.label
                                        : index
                                    "
                                    :id="
                                      field.label != undefined
                                        ? field.label
                                        : index
                                    "
                                  />
                                  <span class="radio-label ml-3">{{
                                    option
                                  }}</span>
                                  <br />
                                </h6> -->
                              </div>

                              <div>
                                <span
                                  class="text-danger text-sm"
                                  :style="textColor"
                                  v-show="
                                    errors.has(
                                      'schedule.' +
                                        (field.label != undefined ? field.label : index)
                                    )
                                  "
                                  >{{
                                    errors.first(
                                      "schedule." +
                                        (field.label != undefined ? field.label : index)
                                    )
                                  }}</span
                                >
                              </div>
                            </div>

                            <!-- =================== -->
                            <div
                              class="vx-col w-full mt-3"
                              v-if="
                                field.shown &&
                                field.type == 'files' &&
                                currentIndex == key1 &&
                                !field.form
                              "
                            >
                              <h4>
                                {{ $t(field.label != undefined ? field.label : $t(index))
                                }}<span :style="textColor" v-if="field.required">*</span>
                              </h4>
                              <div
                                v-for="(file, index3) in field.option_questions"
                                :key="index3"
                                class="w-full"
                              >
                                <label class="w-full mb-1"
                                  >{{ file }}
                                  <span :style="textColor" v-if="field.required">*</span>
                                </label>

                                <template
                                  v-if="
                                    selectedInput[index] &&
                                    selectedInput[index][file] &&
                                    isFile(selectedInput[index][file])
                                  "
                                >
                                  <span class="w-10/12 text-info">
                                    {{ selectedInput[index][file].name }}
                                  </span>
                                  <a
                                    class="w-2/12 text-danger"
                                    @click.prevent="unsetFile(index, file)"
                                    title="Remove"
                                  >
                                    <feather-icon
                                      icon="XIcon"
                                      class="float-right"
                                      svgClasses="h-5"
                                    />
                                  </a>
                                </template>

                                <template v-else>
                                  <div
                                    class="col-12 text-center br-20 p-5 position-relative overflow-hidden files-data"
                                    style="background-color: rgba(255, 255, 255, 0.5)"
                                    @click="
                                      loginUser
                                        ? openModal(`${file}-${index}`)
                                        : $set(preview1, index3, true)
                                    "
                                  >
                                    <input
                                      :ref="file"
                                      type="file"
                                      v-validate="{
                                        required: field.required,
                                        size: 5048,
                                      }"
                                      :key="index"
                                      class="hidden"
                                      :name="`${file}-${index}`"
                                      accept="image/*, application/pdf,doc, pdf, xls, jpg, png, ppt"
                                      :data-vv-as="$t('documents')"
                                      @change="setFiles(index, file, $event)"
                                    />

                                    <div class="w-full">
                                      <i class="fa-solid fa-image f-100"></i>
                                    </div>
                                    <div class="w-full">
                                      <i class="fa-solid fa-upload f-100"></i>
                                    </div>
                                    <b-modal
                                      :title="$t('Documents')"
                                      :id="`${file}-${index}`"
                                      class="book-modal-documents"
                                    >
                                      <!-- <template #modal-header="{ close }">

      </template> -->

                                      <template #default="{ hide }">
                                        <div class="">
                                          <div class="vx-row" v-if="userDocs.length > 0">
                                            <div
                                              v-for="(image, count) in userDocs"
                                              :key="count"
                                              @click="
                                                selectedImageMultiple(
                                                  image.answer,
                                                  `${file}-${index}`,
                                                  index3
                                                )
                                              "
                                            >
                                              <img
                                                v-if="!image.answer.includes('.pdf')"
                                                :src="previewLinks[image.answer]"
                                                alt="Preview"
                                                width="150"
                                                height="150"
                                                class="img-resposive p-2"
                                              />
                                              <img
                                                v-else
                                                class="custom-image-class"
                                                :src="defaultDoc"
                                                width="150"
                                                height="150"
                                                style="border: none"
                                              />
                                            </div>
                                          </div>
                                          <div class="vx-row" v-else>
                                            <div class="w-full text-center p-5">
                                              <h3>{{ $t("NoDocuments") }}</h3>
                                            </div>
                                          </div>
                                        </div>
                                        <!-- <div class="text-center">
              <label for="">No documents saved.</label>
            </div> -->
                                      </template>

                                      <template #modal-footer="{ ok }">
                                        <div class="w-full text-center">
                                          <img
                                            @click="$refs[file][0].click()"
                                            :src="defaultImg"
                                            class="ml-5 mr-5 rounded mt-1"
                                            width="32px"
                                            v-show="false"
                                          />
                                          <b-button
                                            variant="primary"
                                            class="mr-4 mb-4 mt-2 booking-form-btn"
                                            size="md"
                                            :style="buttonCss"
                                            @click="
                                              $bvModal.hide(`${file}-${index}`);
                                              $set(preview1, index3, true);
                                              image = '';
                                            "
                                            >{{ $t("Upload") }}</b-button
                                          >
                                        </div>

                                        <!-- Emulate built in modal footer ok and cancel button actions -->
                                      </template>
                                    </b-modal>
                                    <vs-popup
                                      title="Preview"
                                      class="confirmPopup"
                                      :active.sync="preview1[index3]"
                                    >
                                      <!-- Fine Footer -->
                                      <!-- Modale conferma di prenotazione -->

                                      <div
                                        v-if="previewLinks[image]"
                                        class="w-full p-5 text-center"
                                      >
                                        <img
                                          v-if="!image.includes('.pdf')"
                                          :src="previewLinks[image]"
                                          class="img-responsive"
                                          height="200"
                                        />
                                        <iframe
                                          v-else
                                          class="w-100 custom-image-class"
                                          :src="previewLinks[image]"
                                          height="200"
                                          style="border: none"
                                        />
                                      </div>
                                      <div v-else class="w-full p-5 text-center">
                                        <DropFileForm
                                          @selectedFile="setFiles"
                                          :idx="index"
                                          :labelFile="file"
                                        />
                                      </div>

                                      <div class="w-full text-center">
                                        <b-button
                                          size="md"
                                          @click="
                                            selectedImage2(index, file, image, index3)
                                          "
                                          variant="primary"
                                        >
                                          {{ $t("Select") }}
                                        </b-button>
                                        <!-- <b-button
                      variant="primary"
                      class="mr-4 mt-2 border-primary"
                      @click="$refs.file.click()"
                      >{{ $t("Change") }}</b-button
                    > -->
                                      </div>
                                    </vs-popup>
                                  </div>
                                </template>

                                <!-- <span class="text-info" v-if="imageMultiple.length"> {{ imageMultiple.length }} files</span> -->
                                <br />

                                <span
                                  v-if="errors.has(`schedule.${file}-${field.label}`)"
                                  class="text-danger text-sm mb-1"
                                  :style="textColor"
                                >
                                  {{ errors.first(`schedule.${file}-${field.label}`) }}
                                </span>
                              </div>
                            </div>

                            <!-- INPUT -->
                            <div
                              class="vx-col md:w-full w-full mt-4 multi-input"
                              v-if="
                                field.shown &&
                                field.type == 'input' &&
                                currentIndex == key1 &&
                                field.form
                              "
                            >
                              <label :style="textColor" class="vs-input--label">{{
                                $t(field.label != undefined ? field.label : $t(index))
                              }}</label>
                              <b-form-input
                                autofocus
                                size="lg"
                                :key="index"
                                v-validate="{
                                  required: field.required,
                                  email: index == 'email' ? true : false,
                                  max:
                                    index == 'age'
                                      ? 2
                                      : index == 'first_name' || index == 'last_name'
                                      ? 20
                                      : false,
                                  min_value: index == 'age' ? 1 : false,
                                }"
                                :name="field.label != undefined ? field.label : index"
                                :data-vv-as="
                                  $t(field.label != undefined ? field.label : index)
                                "
                                v-model="scheduleEvent[index]"
                                class="w-full"
                                :disabled="
                                  index == 'email'
                                    ? scheduleEvent['id']
                                      ? true
                                      : false
                                    : false
                                "
                                :type="index == 'age' ? 'number' : 'text'"
                              ></b-form-input>
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="
                                  errors.has(
                                    'schedule.' +
                                      (field.label != undefined ? field.label : index)
                                  )
                                "
                                >{{
                                  errors.first(
                                    "schedule." +
                                      (field.label != undefined ? field.label : index)
                                  )
                                }}</span
                              >
                            </div>
                            <!-- PHONE NUMBER -->
                            <div
                              class="vx-col md:w-full w-full mt-8"
                              v-if="
                                field.shown &&
                                field.type == 'contact' &&
                                currentIndex == key1 &&
                                field.form
                              "
                            >
                              <label :style="textColor" class="contact_number_label">{{
                                $t(index)
                              }}</label>
                              <!--
                        <span v-if="field.required">*</span> -->
                              <vue-tel-input
                                :autofocus="true"
                                :key="index"
                                size="large"
                                v-validate="{
                                  required: field.required,
                                  regex: /^(?=.*[0-9])[- +()0-9]+$/,
                                  min: 12,
                                }"
                                v-model="scheduleEvent[index]"
                                class="w-full flag-plugin"
                                v-on:country-changed="countryChanged"
                                v-bind="bindProps"
                                @onInput="onInput"
                                v-on:blur="appendCode"
                                :data-vv-as="$t(index)"
                              ></vue-tel-input>
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="errors.has('schedule.' + index)"
                                >{{ errors.first("schedule." + index) }}</span
                              >
                            </div>
                            <!-- SELECT -->
                            <div
                              class="vx-col md:w-full w-full mt-8"
                              v-if="
                                field.shown &&
                                field.type == 'select' &&
                                currentIndex == key1 &&
                                field.form
                              "
                            >
                              <label :style="textColor">{{ $t(index) }}</label>
                              <!-- <span v-if="field.required">*</span>  -->
                              <v-select
                                autofocus
                                class="mt-1 w-full"
                                v-validate="{ required: field.required }"
                                v-model="scheduleEvent[index]"
                                :options="genderArray"
                                :name="field.label != undefined ? field.label : index"
                                :data-vv-as="$t(index)"
                                :placeholder="$t('Select') + $t(index).toLowerCase()"
                              >
                                <template v-slot:option="option">
                                  <span :class="option.icon">{{ option.label }} </span>
                                  <feather-icon
                                    v-if="
                                      scheduleEvent[index] &&
                                      scheduleEvent[index] == option.label
                                    "
                                    icon="CheckIcon"
                                    class="float-right"
                                    svgClasses="w-5 h-5"
                                  />
                                </template>
                              </v-select>
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="errors.has('schedule.' + index)"
                                >{{ errors.first("schedule." + index) }}</span
                              >
                            </div>

                            <div
                              class="vx-col md:w-full w-full mt-8"
                              v-if="
                                field.shown &&
                                field.type == 'calender' &&
                                currentIndex == key1 &&
                                field.form
                              "
                            >
                              <label :style="textColor" class="contact_number_label">{{
                                $t(index)
                              }}</label>
                              <!-- <span v-if="field.required">*</span>  -->

                              <b-form-datepicker
                                autofocus
                                :placeholder="$t('Select') + $t(index).toLowerCase()"
                                v-model="scheduleEvent[index]"
                                v-validate="{ required: field.required }"
                                :format="format"
                                :disabled-dates="state.disabledDates"
                                :name="'schedule.' + index"
                                :data-vv-as="$t(index)"
                                class="p-1 datepick"
                                :date-format-options="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }"
                                :show-decade-nav="showDecadeNav"
                                :hide-header="hideHeader"
                              ></b-form-datepicker>
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="errors.has('schedule.' + index)"
                                >{{ errors.first("schedule." + index) }}</span
                              >
                            </div>

                            <div
                              class="vx-col md:w-1/2 w-full mt-8 identity"
                              v-if="
                                field.shown &&
                                field.type == 'file' &&
                                currentIndex == key1 &&
                                field.form
                              "
                            >
                              <label :style="textColor">{{ $t(index) }}</label>
                              <!-- <span v-if="field.required">*</span>  -->
                              <v-select
                                class="mt-1 w-full"
                                v-validate="{ required: field.required }"
                                v-model="scheduleEvent['type']"
                                :options="documentTypeArray"
                                :name="field.label != undefined ? field.label : index"
                                :data-vv-as="$t(index)"
                                :placeholder="$t('Select') + $t(index).toLowerCase()"
                              >
                                <template v-slot:option="option">
                                  <span :class="option.icon">{{ option.label }} </span>
                                  <feather-icon
                                    v-if="
                                      scheduleEvent['type'] &&
                                      scheduleEvent['type'].code == option.code
                                    "
                                    icon="CheckIcon"
                                    class="float-right"
                                    svgClasses="w-5 h-5"
                                  />
                                </template>
                              </v-select>
                              {{ errors }}
                              {{ index }}
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="errors.has('schedule.' + index)"
                                >{{ errors.first("schedule." + index) }}</span
                              >
                            </div>

                            <!-- =================== -->
                            <div
                              class="vx-col md:w-1/2 w-full mt-8"
                              v-if="
                                field.shown &&
                                field.type == 'file' &&
                                currentIndex == key1 &&
                                field.form
                              "
                            >
                              <label :style="textColor">{{
                                $t("Upload") + " " + $t("document").toLowerCase()
                              }}</label>
                              <span v-if="field.required">*</span>
                              <img
                                :src="url"
                                class="mr-8 rounded mt-1"
                                width="85px"
                                @error="errorImage"
                              />

                              <input
                                ref="uploadDocumentInput"
                                type="file"
                                v-validate="{
                                  required:
                                    field.required &&
                                    url.includes('default_upload.d4c75de8.png'),
                                  size: 2048,
                                }"
                                class="hidden"
                                accept="image/*, application/pdf"
                                name="uploadDocument"
                                id="uploadDocument"
                                :data-vv-as="$t('document')"
                                @change="selectedFile"
                              />

                              <!-- $bvModal.show(`schedule.${index}`) -->
                              <b-button
                                v-if="loginUser"
                                variant="primary"
                                class="mr-4 mb-4 mt-2 booking-form-btn"
                                size="lg"
                                :style="buttonCss"
                                @click="$bvModal.show(`schedule.${index}`)"
                                >{{ $t("Upload") }}</b-button
                              >
                              <b-button
                                v-else
                                variant="primary"
                                class="mr-4 mb-4 mt-2 booking-form-btn"
                                size="lg"
                                :style="buttonCss"
                                @click="preview = true"
                                >{{ $t("Upload") }}</b-button
                              >

                              <br />
                              <span
                                class="text-danger text-sm"
                                :style="textColor"
                                v-show="errors.has('schedule.' + 'uploadDocument')"
                                >{{ errors.first("schedule." + "uploadDocument") }}</span
                              >
                            </div>

                            <b-modal
                              :title="$t('Documents')"
                              :id="`schedule.${index}`"
                              class="book-modal-documents"
                            >
                              <!-- <template #modal-header="{ close }">

      </template> -->

                              <template #default="{ hide }">
                                <div class="">
                                  <div class="vx-row" v-if="userDocs.length > 0">
                                    <div
                                      v-for="(image, count) in userDocs"
                                      :key="count"
                                      @click="
                                        selectedImage(image.answer, `schedule.${index}`)
                                      "
                                    >
                                      <img
                                        v-if="!image.answer.includes('.pdf')"
                                        :src="previewLinks[image.answer]"
                                        alt="Preview"
                                        width="150"
                                        height="150"
                                        class="img-resposive p-2"
                                      />
                                      <img
                                        v-else
                                        class="custom-image-class"
                                        :src="defaultDoc"
                                        width="150"
                                        height="150"
                                        style="border: none"
                                      />
                                    </div>
                                  </div>
                                  <div class="vx-row" v-else>
                                    <div class="w-full text-center p-5">
                                      <h3>{{ $t("NoDocuments") }}</h3>
                                    </div>
                                  </div>
                                </div>
                                <!-- <div class="text-center">
              <label for="">No documents saved.</label>
            </div> -->
                              </template>

                              <template #modal-footer="{ ok }">
                                <div class="w-full text-center">
                                  <input
                                    ref="uploadDocumentInput"
                                    type="file"
                                    v-validate="{
                                      required:
                                        field.required &&
                                        url.includes('default_upload.d4c75de8.png'),
                                      size: 2048,
                                    }"
                                    class="hidden"
                                    accept="image/*, application/pdf"
                                    name="uploadDocument"
                                    id="uploadDocument"
                                    :data-vv-as="$t('document')"
                                    @change="selectedFile"
                                  />

                                  <b-button
                                    variant="primary"
                                    class="mr-4 mb-4 mt-2"
                                    size="lg"
                                    :style="buttonCss"
                                    @click="preview = true"
                                    >{{ $t("Upload") }}</b-button
                                  >
                                  <br />
                                </div>

                                <!-- Emulate built in modal footer ok and cancel button actions -->
                              </template>
                            </b-modal>

                            <!-- ==================== -->
                          </div>
                        </template>

                        <div
                          class="w-full"
                          :class="{ flex: !showFormStartMeeting }"
                          v-if="!showLoginForm"
                        >
                          <b-button
                            v-if="showFormStartMeeting"
                            ref="schedule-event-btn"
                            variant="primary"
                            size="lg"
                            @click="schedule('schedule')"
                            class="w-full mt-5 p-5 booking-form-btn"
                            :style="buttonCss"
                            >{{
                              this.type == "walkin"
                                ? $t("StartMeeting")
                                : $t("ScheduleEvent")
                            }}</b-button
                          >
                          <template v-else>
                            <b-button
                              v-if="currentIndex != 0"
                              variant="primary"
                              size="lg"
                              @click="backForm(currentIndex)"
                              class="booking-form-btn mt-5 block multi-form-lp w-1/2 p-5 mt-5 mr-1"
                              :style="buttonCss"
                              >{{ $t("Back") }}</b-button
                            >
                            <b-button
                              variant="primary"
                              size="lg"
                              ref="nextFormBtn"
                              @click="nextForm(currentIndex)"
                              class="mt-5 p-5 booking-form-btn"
                              :class="{
                                'w-full': currentIndex == 0,
                                'block multi-form-lp w-1/2 mt-5 ml-1': currentIndex != 0,
                              }"
                              :style="buttonCss"
                              >{{ $t("Next") }}</b-button
                            >
                          </template>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div v-if="showLoginForm">
                    <h6 :style="textColor">{{ $t("Login") }}</h6>
                    <form id="login" data-vv-scope="login">
                      <div class="vx-row">
                        <div class="vx-col md:w-full w-full mt-3">
                          <label :style="textColor" class="contact_number_label">{{
                            $t("Email")
                          }}</label>
                          <b-form-input
                            v-validate="'required|email'"
                            name="email"
                            v-model="scheduleEvent.email"
                            class="w-full"
                            :data-vv-as="$t('Email')"
                          ></b-form-input>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('login.email')"
                            >{{ errors.first("login.email") }}</span
                          >
                        </div>
                        <div class="vx-col md:w-full w-full mt-3">
                          <label :style="textColor" class="contact_number_label">{{
                            $t("Password")
                          }}</label>

                          <b-form-input
                            v-validate="'required|min:6'"
                            name="password"
                            v-model="scheduleEvent.password"
                            class="w-full"
                            type="password"
                            :data-vv-as="$t('Password')"
                          ></b-form-input>
                          <span
                            class="text-danger text-sm"
                            :style="textColor"
                            v-show="errors.has('login.password')"
                            >{{ errors.first("login.password") }}</span
                          >
                          <div class="mt-2">
                            <label id="password" class="float-right pull-right">
                              <span>
                                <router-link to="/user/forgot-password">{{
                                  $t("ForgotPassword")
                                }}</router-link>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col">
                        <b-button
                          @click="schedule('login')"
                          class="mt-5 block float-left pl-5 pr-5 login"
                          :style="buttonCss"
                          variant="primary"
                          size="lg"
                          >{{ $t("Login") }}</b-button
                        >
                        <b-button
                          size="lg"
                          :style="buttonCss"
                          variant="primary"
                          v-if="!this.isReschedule"
                          @click="showLoginForm = false"
                          class="mt-5 block float-left ml-5 pl-5 pr-5 login"
                          >{{ $t("Cancel") }}</b-button
                        >
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!errorMsg && showConfirmation">
            <div class="profile-header app-details">
              <b-button :style="buttonCss" size="lg" variant="primary" @click="back">
                <b-icon
                  icon="arrow-left"
                  variant="white"
                  :style="'color:' + buttonCss.color + ' !important'"
                ></b-icon>
              </b-button>
              <div class="relative">
                <div class="pointer-events">
                  <div>
                    <b-avatar
                      v-if="profile_image != 'loading'"
                      button
                      variant="light"
                      @click="redirectToWebsiteUrl"
                      :class="
                        (!header && profile_image == null) ||
                        (header && profile_image == null) ||
                        (!header && profile_image != null)
                          ? 'avatar-default'
                          : ''
                      "
                      class="user-profile-img img-center"
                      :src="header && profile_image ? profile_image : defaults"
                      size="85px"
                    ></b-avatar>
                  </div>
                </div>
                <div class="company-center mt-5" :style="textColor">
                  <div
                    v-if="
                      this.appointmentDetails.is_booked != true &&
                      (this.appointmentDetails.is_confirmed ||
                        this.appointmentDetails.type == 'walkin')
                    "
                  >
                    <h4 :style="textColor">{{ $t("Confirmed") }}</h4>
                    <p class="mt-2">
                      {{ $t("AppointmentBookedText") }}
                      {{ appointmentDetails.staff_name }}.
                      <br />
                      <span v-if="isLogin">
                        {{ $t("EmailReceive") }}:
                        <u>{{ userdata.email }}</u>
                      </span>
                    </p>
                  </div>
                  <div
                    v-else-if="
                      this.appointmentDetails.is_booked != true &&
                      !this.appointmentDetails.is_confirmed
                    "
                  >
                    <h4 :style="textColor">{{ $t("AppointmentRequested") }}</h4>
                    <p class="mt-2">
                      {{ $t("AppointmentBookedText2") }}
                      {{ appointmentDetails.staff_name }},
                      {{ $t("Requested") }}
                      <br />
                      <span>
                        {{ $t("Confirmation") }}
                        <u>{{ userdata.email }}</u>
                      </span>
                    </p>
                  </div>
                  <div v-else>
                    <h4>{{ $t("Booked") }}</h4>
                    <p class="mt-2">{{ $t("BookedAppointmentText") }}</p>
                  </div>
                  <p
                    class="mt-5"
                    v-if="
                      this.appointmentDetails.is_confirmed ||
                      this.appointmentDetails.type == 'walkin'
                    "
                  >
                    <a :href="appointmentDetails.ics_file" type="download">
                      <i class="feather icon-plus-circle mr-1"></i>
                      <span class="text">{{ $t("AddToCalender") }}</span>
                    </a>
                  </p>
                </div>
                <br />
                <div class="appointment-details">
                  <div
                    class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
                  >
                    <div
                      class="department-list mt-2 ml-5 mr-5 mb-10 w-full"
                      :style="textColor"
                    >
                      <div class="department-header">
                        <div class="marker" :style="buttonCss"></div>
                        <div class="department-name">
                          <h5 :style="textColor">
                            {{ department.department_name }}
                          </h5>
                        </div>
                      </div>
                      <div class="department-desc">
                        <p class="mt-2" style="text-transform: capitalize">
                          <i class="feather icon-calendar mr-2"></i>
                          {{ selectedTime.start_time }} - {{ selectedTime.end_time }},
                          <template v-if="selectedDate">{{ selectedDate }}</template>
                        </p>
                      </div>
                      <div class="department-desc mt-2">
                        <p class="mt-2">
                          <i class="feather icon-phone-call mr-2"></i>
                          {{ department.company_contact }}
                        </p>
                      </div>

                      <div v-if="isPremiumMeeting && !paymentDone" class="mt-5">
                        <h5 style="text-align: left !important">
                          <span :style="textColor">{{ $t("PaymentDetails") }}:</span>
                        </h5>
                        <div class="mt-2">
                          <p style="text-align: left !important">
                            {{ $t("PaymentMsg") }}
                          </p>
                        </div>
                        <div v-if="!showPayForm" class="mt-2">
                          <b-button
                            variant="primary"
                            size="lg"
                            class="mt-5"
                            :style="buttonCss"
                            @click="payForm()"
                            >{{ $t("PayNow") }}</b-button
                          >
                        </div>
                        <div v-if="showPayForm" class="mt-2" style="text-align: left">
                          <form data-vv-scope="payment">
                            <div class="vx-row">
                              <div class="mt-3 vx-col w-full">
                                <label :style="textColor" class="contact_number_label">{{
                                  $t("CardHolderName")
                                }}</label>

                                <b-form-input
                                  v-validate="'required'"
                                  name="card_holder_name"
                                  :data-vv-as="$t('CardHolderName')"
                                  v-model="cardHolderName"
                                  class="w-full"
                                ></b-form-input>

                                <span
                                  class="text-danger text-sm"
                                  :style="textColor"
                                  v-show="errors.has('payment.card_holder_name')"
                                  >{{ errors.first("payment.card_holder_name") }}</span
                                >
                              </div>
                              <div class="mt-3 vx-col w-full">
                                <label :style="textColor">{{
                                  $t("CreditDebitCard.default")
                                }}</label>
                                <div id="card-element" class="field"></div>
                                <span
                                  class="text-danger text-sm"
                                  :style="textColor"
                                  v-show="stripValidationError"
                                  >{{
                                    $t(stripValidationError.replace(/[\s\/'.]/g, "")) !==
                                    stripValidationError.replace(/[\s\/'.]/g, "")
                                      ? $t(stripValidationError.replace(/[\s\/'.]/g, ""))
                                      : stripValidationError
                                  }}</span
                                >
                              </div>
                              <div class="vx-col pay-now">
                                <b-button
                                  class="mt-5"
                                  :disabled="payDisabled"
                                  variant="primary"
                                  size="lg"
                                  :style="buttonCss"
                                  @click="submitPaymentMethod"
                                  >{{
                                    $t("Pay") +
                                    " " +
                                    this.appointmentDetails.amount +
                                    " " +
                                    this.appointmentDetails.currency
                                  }}</b-button
                                >
                              </div>
                              <div class="vx-col vx-col w-full mt-5">
                                <span
                                  class="text-danger text-sm"
                                  :style="textColor"
                                  v-show="stripErrors"
                                  >{{
                                    $t(stripErrors.replace(/[\s\/'.]/g, "")) !==
                                    stripErrors.replace(/[\s\/'.]/g, "")
                                      ? $t(stripErrors.replace(/[\s\/'.]/g, ""))
                                      : stripErrors
                                  }}</span
                                >
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div v-if="paymentDone" class="mt-10">
                        <h5 class="green-text">{{ $t("PaymentDone") }}</h5>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="(!isPremiumMeeting || paymentDone) && startMeet"
                    class="vx-row align-center"
                  >
                    <b-button
                      variant="primary"
                      size="lg"
                      :style="buttonCss"
                      @click="startConf()"
                      >{{ $t("StartMeeting") }}</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="errorMsg" class="error-msg">
            <h4 class="center">
              {{ alreadyCancelMsg ? alreadyCancelMsg : $t("CompanyNotFound") }}
            </h4>
          </div>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import { getFile } from "@/api/staff";
// if(window.location.hash != '')
//   window.location.hash = '';
import moment from "moment";
import $ from "jquery";
import { VueTelInput } from "vue-tel-input";
import {
  phoneConfig,
  parseStringToURLFriendly,
  urlToFile,
  debounce,
} from "@/utils/helper";
// For custom error message
import { Validator } from "vee-validate";
import { getStripeKey } from "@/utils/stripe";
import I18n from "@/layouts/components/navbar/components/I18n.vue";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import "moment-timezone";
import Cookies from "js-cookie";
import { getErrorMessage, sleep } from "@/utils/helper";
import { setLocale, getLocale } from "@/utils/auth";
// import '@/utils/prevent-back';
import DropFileForm from "@/components/DropFileForm.vue";
import { parse } from "date-fns";

const channels = {
  private: [],
  public: [],
  walkinDepartment: [],
};
let date_slots = [];
export default {
  data() {
    return {
      logger: null,
      font_size: {
        title: 18,
        paragraph: 18,
      },
      indexFile: "",
      flagWalk: false,
      defaultDoc: require("@/assets/images/img/pdf.png"),
      arr: [],
      loginUser: [],
      imageObject: [],
      image: [],
      userDocs: [],
      previewLinks: [],
      preview: false,
      preview1: [],
      temp: [],
      imageCount: [1, 2, 3, 4, 5],
      path: require("@/assets/images/portrait/small/avatar-s-9.jpg"),

      defaults: require("@/assets/images/logo/bip.png"),
      header: false,
      temp: [],
      multi_form: false,
      formShow: true,
      qShow: false,
      currentIndex: 0,
      imageMultiple: [],
      availableStaffIds: [],
      questionOptions: [],
      selectedInput: {},
      selectedOptions: [],
      // selectedText: [],
      // selectedCheck: [],
      questionsFields: [],

      checkFields: [],
      showWalkin: false,
      images: "",
      url: require("@/assets/images/portrait/small/default_upload.png"),
      defaultImg: require("@/assets/images/portrait/small/default_upload.png"),
      isReschedule: false,
      cookie_appointment_id: null,
      fields: { text: "timezone" },
      allowFiltering: true,
      state: {
        disabledDates: {
          // Disable all dates up to specific date
          from: new Date(), // Disable all dates after specific date
        },
      },

      col: "lg:w-1/2 xl:w-1/2",
      calendarData: {},
      department: {},
      company: {},
      slug: "",
      errorMsg: false,
      profile_image: "loading",
      slots_availablity: [],
      currentDate: new Date(),
      endDate: new Date(),
      disabledDates: [],
      nextMonthStartDate: new Date(),
      dateMarked: [],
      slotMsg: false,
      slots: [],
      showTimeSlots: false,
      slectedDate: "",
      currentSelectedDate: "",
      showConfirm: false,
      startMeet: false,
      scheduleEvent: {},
      guestEmails: [],
      isGuestAdd: false,
      selectedTime: "",
      timeIndex: "",
      showLoginForm: false,
      showConfirmation: false,
      appointmentDetails: [],
      userdata: [],
      isLogin: false,
      bindProps: phoneConfig(this.$t("ContactNumber")),
      days: this.$t("dayNames"),
      months: this.$t("monthNames"),
      showCalender: true,
      selectedCurrentDate: "",
      showPayForm: false,
      isPremiumMeeting: false,
      stripeAPIToken: getStripeKey(),
      cardHolderName: "",
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCVCElement: null,
      elements: null,
      stripe: null,
      stripValidationError: "",
      intentToken: "",
      addPaymentStatus: 0,
      addPaymentStatusError: "",
      card: null,
      stripErrors: "",
      paymentDone: false,
      payDisabled: false,
      companyDetails: true,
      staffSlug: true,
      hide: true,
      formFields: [],

      genderArray: [this.$t("Male"), this.$t("Female"), this.$t("Prefernottosay")],
      documentTypeArray: [
        { code: 1, label: this.$t("Passport"), _label: "Passport" },
        { code: 2, label: this.$t("IdentityCard"), _label: "IdentityCard" },
        { code: 3, label: this.$t("DrivingLicense"), _label: "DrivingLicense" },
      ],
      format: "yyyy-MM-dd",
      id: "",
      timeZone: "",
      options: [],
      dateSel: "",
      colorx: "#c72a75",
      type: "normal",
      startMeeting: "",
      is_confirm: true,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      selectTime: {
        day: 15,
        date: "15-06-2021",
        hide: true,
        isMouseToLeft: false,
        isMouseToRight: false,
        isHovered: false,
        isDateRangeStart: false,
        isDateRangeEnd: false,
        hideLeftAndRightDays: false,
        isToday: true,
        isMarked: true,
      },
      selected: false,
      start_time: "",
      start_date: "",
      index: "",
      decode: "",
      key: "",
      cancel: "",
      showDecadeNav: true,
      hideHeader: true,
      firstDay: new Date(),
      decodeCancel: "",
      cancelAppId: "",
      cancelSlug: "",
      rescheduleSlug: "",
      highlightDate: "",
      alreadyCancelMsg: "",
      inputFlag: true,
      buttonCss: {},
      textColor: {},
      website_url: null,
      guestEmailValidations: [
        {
          classes: "danger",
          rule: ({ text }) => {
            return (
              /^([a-zA-Z0-9._%-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(text) === false
            );
          },
          disableAdd: true,
        },
      ],
    };
  },
  components: {
    VueTelInput,
    I18n,
    "v-select": vSelect,
    Datepicker,
    DropFileForm,
    VueTagsInput,
  },
  watch: {
    start_time(start_time) {
      this.slots = this.slots.map((slot) => {
        slot.isActive = start_time == slot.start_time;
        return slot;
      });
    },
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.displayError();
        this.scheduleEvent.gender = this.$t(this.scheduleEvent.gender);
        this.show = true;
        this.showCalender = false;
        setTimeout(() => {
          this.days = this.$t("dayNames");
          this.months = this.$t("monthNames");
          this.showCalender = true;
          moment.locale(value);
          this.slectedDate = moment(this.selectedCurrentDate, "D/M/YYYY").format(
            "dddd, MMMM D, YYYY"
          );
          this.show = false;
          this.genderArray = [
            this.$t("Male"),
            this.$t("Female"),
            this.$t("Prefernottosay"),
          ];
          this.documentTypeArray = [
            { code: 1, label: this.$t("Passport") },
            { code: 2, label: this.$t("IdentityCard") },
            { code: 3, label: this.$t("DrivingLicense") },
          ];
        }, 100);
      },
    },
    error(nerr, oerr) {
      this.$toasted.show(nerr, {
        className: "top-alert",
        position: "top-center",
        type: "error",
        duration: 2000,
      });
    },
  },
  computed: {
    walkinEnabled() {
      return (
        this.department &&
        !this.department.is_physical_appointment &&
        this.availableStaffIds.length > 0
      );
    },
    selectedDate() {
      if (!this.calendarData || !this.calendarData.selectedDate) return null;
      const date = parse(this.calendarData.selectedDate, "d/M/yyyy", new Date());
      return Intl.DateTimeFormat(this.$i18n.locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      }).format(date);
    },
    showFormStartMeeting() {
      return (
        (this.walkinEnabled || this.type != "walkin") &&
        this.currentIndex >= this.formLength - 1
      );
    },
    formLength() {
      return this.formKeys.length;
    },
    formKeys() {
      return Object.keys(this.formFieldsc1);
    },
    formFieldsc1() {
      const f = {};
      for (let label in this.formFields) {
        if (this.formFields[label].shown) f[label] = this.formFields[label];
      }
      this.questionsFields.forEach((el) => {
        if (el.shown) f[el.label] = el;
      });
      return f;
    },
    departmentCount() {
      return this.company && this.company.departments
        ? this.company.departments.length
        : 0;
    },

    activeUserInfo() {
      return this.$store.getters.currentUser;
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keydownHandler);
    channels.private.forEach((channel) => {
      window.Echo.leave(`private-${channel}`);
    });
    channels.public.forEach((channel) => {
      window.Echo.leave(`${channel}`);
    });
    channels.walkinDepartment.forEach((channel) => {
      window.Echo.leave(`${channel}`);
    });
    window.removeEventListener("hashchange", this.onhashchangeHandler);
  },
  async mounted() {
    this.getTimeZones();

    window.addEventListener("keydown", this.keydownHandler);

    this.timeZone =
      moment.tz.guess() !== "Asia/Calcutta" ? moment.tz.guess() : "Asia/Kolkata";

    //company slug
    if (
      (!this.cancel && !this.reschedule) ||
      this.$route.params.reschedule == "reschedule"
    ) {
      if ($("#company").val() != undefined) {
        this.slug = $("#company").val();
      } else {
        this.slug = this.$route.params.slug;
      }

      //staff direct url
      if ($("#direct-staff").val() != undefined) {
        this.staffSlug = $("#direct-staff").val();
      } else {
        this.staffSlug = this.$route.params.staffslug;
      }

      //staff direct url
      if ($("#department").val() != undefined) {
        this.staffSlug = $("#department").val();
      } else {
        this.staffSlug = this.$route.params.staffslug;
      }

      //staff direct url
      if ($("#department-id").val() != undefined) {
        this.id = $("#department-id").val();
      }

      //appointment reschedule

      if (Cookies.get("appointment_id_reschedule") != null) {
        this.cookie_appointment_id = Cookies.get("appointment_id_reschedule");
      }

      if (this.$route.params.reschedule == "reschedule") {
        this.isReschedule = true;
        if (this.cookie_appointment_id == null) {
          window.location.href = "/" + this.slug;
        }
      }

      if (this.staffSlug) {
        console.log("staffSlug");
        await this.getDepartmentDetailsBySlug();
      } else if (this.id) {
        console.log("selectDpt", this.id);
        await this.selectDpt(this.id);
      }
      console.log("getCompanyDetails");
      await this.getCompanyDetails();
    }

    if (this.key && this.slug) {
      this.decode = window.atob(this.key);
      console.log("decode", this.decode);
      let [department_id, timeSlot, timeDate, timeZone] = this.decode.split("&");
      this.highlightDate = timeDate;

      this.checkAppointment(department_id, timeSlot, timeDate, timeZone);
      this.currentDate = moment(new Date(timeDate), "D/M/YYYY").format("D/M/YYYY");
      this.highlightDate = timeDate;
    }
    if (this.cancel) {
      this.checkCancelAppointment();
      // this.cancelSlug = company_slug || "";
    }
    if (this.reschedule) {
      let decode = window.atob(this.reschedule);

      const [
        appointment_id,
        department_id,
        timeSlot,
        timeDate,
        timeZone,
        user_id,
      ] = decode.split("&");
      console.log("reschedule >> ", {
        appointment_id,
        department_id,
        timeSlot,
        timeDate,
        timeZone,
        user_id,
      });
      if (user_id) this.autoLogin(user_id);
      this.cancelAppId = appointment_id;
      this.highlightDate = timeDate;
      await this.checkAppointment(department_id, timeSlot, timeDate, timeZone);
    }

    // console.log('reschedule', this.reschedule)
    // console.log('cancel', this.cancel);
    // console.log(!this.reschedule && !this.cancel)
    // subscribe socket channel at the end
    if (!this.reschedule && !this.cancel) {
      this.availableStaffIds = [...this.$store.state.auth.onlineIds];
      // when user is not logged in
      if (this.$store.getters.token == null) this.$store.dispatch("staffOnlineIdsInit");
    }

    if (getLocale() == undefined && this.company.language) {
      setLocale(this.company.language);
      this.$root.$i18n.locale = this.company.language;
    }
    this.isValid = this.header = this.$store.getters.header;

    // if (this.header) this.profile_image = this.defaults;
    this.setLocalData();
  },
  created() {
    this.logger = this.$log.fileError("views/frontend/BookAppointment.vue");
    let logger = this.$store.getters.currentUser;

    this.loginUser = logger.id != undefined ? logger : 0;
    this.key = this.$route.params.key || null;
    this.cancel = this.$route.params.cancel || null;
    this.reschedule = this.$route.params.reschedule || null;
    if (this.cancel) this.cancelSlug = this.$route.params.slug || null;
    if (this.reschedule) this.cancelSlug = this.$route.params.slug || null;
    window.addEventListener("hashchange", this.onhashchangeHandler);
    let id = this.$store.getters.currentUser.id;
    if (id) this.getDocumentAppointments(id);
  },
  methods: {
    keydownHandler(e) {
      const whiteList = ["BUTTON", "A"];
      const isSelectOpen = document.querySelector(".v-select.vs--open");
      if (
        e.key == "Enter" &&
        whiteList.indexOf(document.activeElement.tagName) < 0 &&
        !isSelectOpen
      ) {
        let nextBtnEl = null;
        if (this.$refs.nextFormBtn) {
          nextBtnEl = Array.isArray(this.$refs.nextFormBtn)
            ? this.$refs.nextFormBtn[0]
            : this.$refs.nextFormBtn;
        }

        const scheduleEventBtnEl = Array.isArray(this.$refs["schedule-event-btn"])
          ? this.$refs["schedule-event-btn"][0]
          : this.$refs["schedule-event-btn"];
        if (nextBtnEl) {
          sleep(0.5).then(() => {
            const telEl = document.querySelector("input.vti__input");
            const selectEl = document.querySelector("div.v-select input.vs__search");
            const datepickerEl = document.querySelector("div.b-form-datepicker button");

            if (telEl) telEl.focus();
            if (selectEl) selectEl.focus();
            if (datepickerEl) datepickerEl.click();
          });
          nextBtnEl.click();
        } else if (scheduleEventBtnEl) scheduleEventBtnEl.click();
      }
    },
    openModal(id) {
      this.indexFile = id;
      this.$bvModal.show(id);
    },
    errorImage() {
      this.url = require("@/assets/images/portrait/small/default_pdf.png");
    },
    setLocalData() {
      if (this.company.id !== undefined) {
        localStorage.setItem("client_company_id", this.company.id);
        localStorage.setItem("client_company_slug", this.company.company_slug);
      }
    },
    visibleStart() {
      if (this.availableStaffIds) {
        const filteredArray = this.availableStaffIds.filter((value) => {
          this.startMeeting.availableStaffIds.includes(value);
        });
        this.startMeeting.available_staffs = filteredArray.length > 0 ? true : false;
      } else this.startMeeting.available_staffs = false;
      return this.startMeeting.available_staffs;
    },
    timezoneChanged(timezone) {
      this.getDepartmentDetails().then(() => {
        this.getTimeSlots(this.dateSel);
      });
    },
    async showFile(filename, type) {
      if (this.previewLinks[filename]) return;
      const response = await getFile(`appointment-documents/${filename}`);
      if (response.data) {
        let url = await URL.createObjectURL(response.data);
        const file = await urlToFile(url, filename, "image/*");
        this.images = file;
        this.$set(this.previewLinks, filename, url);
      }
    },
    async selectedImageMultiple(image, id, index) {
      this.image = "";
      this.$set(this.preview1, index, true);
      await this.showFile(image, "image");
      this.image = image;

      const firstPart = id.split("-")[0];

      this.$bvModal.hide(id);
      this.arr.push(firstPart);
    },
    async getImage(filename) {
      if (filename.length > 0) {
        const response = await getFile(`appointment-documents/${filename}`);
        let url = await URL.createObjectURL(response.data);
        const file = await urlToFile(url, filename, "image/*");
        this.imageObject = file;
      }
    },
    showImage(idx) {
      console.log(this.arr);
      let label = this.arr[0];
      this.arr = [];
      console.log("test", this.selectedInput);
      let check = this.selectedInput[idx];
      if (!check) this.$set(this.selectedInput, idx, {});
      this.$set(this.selectedInput[idx], label, this.imageObject);
      console.log(this.imageObject);
      console.log(idx, "--", label);
      console.log("this.selectedInput[idx]", this.selectedInput[idx]);
    },
    async selectedImage2(idx, label, name, fileIndex = null) {
      this.$set(this.preview1, fileIndex, false);
      await this.getImage(name);
      let index = this.indexFile.split("-")[1];
      this.indexFile = "";
      this.showImage(index);
    },

    // async getFile(filename) {
    //   // this.show = true;
    //   const ext = filename.split(".").pop();
    //   const response = await getFile(`appointment-documents/${filename}`);
    //   const url = URL.createObjectURL(response.data);
    //   urlToFile(url, filename, "image/*").then(function (file) {

    //   });
    //   this.show = false;
    // },
    catchMethod(error) {
      this.logger(arguments.callee.name, error);

      this.show = false;
      // Error response
      this.error =
        this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
          ? this.$t(error.replace(/[\s\/]/g, ""))
          : error;
      this.$toasted.show(this.error, {
        className: "top-alert",
        position: "top-center",
        type: "error",
        duration: 2000,
      });
      return false;
    },
    getDocumentAppointments(id) {
      this.show = true;
      var data = {
        id: id,
        params: { question_type: "file" },
      };
      let api = "GetUserDocuments";
      this.$store
        .dispatch(api, data)
        .then((res) => {
          this.show = false;
          this.userDocs = res.data.data;
          this.userDocs.forEach((el) => {
            if (el.answer) {
              this.showFile(el.answer, "image");
            }
          });
        })
        .catch((error) => {
          this.catchMethod(error);
        });
    },
    async selectedImage(image, id) {
      this.preview = true;
      await this.showFile(image, "image");
      this.image = image;
      this.$bvModal.hide(id);
      await this.getImage(image);
    },
    selectedImage1() {
      this.setUploadImage();
    },
    setUploadImage() {
      if (this.imageObject.type == "application/pdf")
        this.url = require("@/assets/images/portrait/small/default_pdf.png");
      else this.url = URL.createObjectURL(this.imageObject);
      this.preview = false;
      this.imagesObject = [];
    },

    nextForm(index) {
      this.$validator.validateAll("schedule").then((valid) => {
        console.log(`validation:schedule:${this.currentIndex}`, valid);
        if (!valid) {
          return false;
        } else {
          let length = this.formLength;
          if (this.currentIndex <= length) {
            this.currentIndex = parseInt(index);
            ++this.currentIndex;
          }
        }
      });
    },
    backForm(index) {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },

    isFile(file) {
      return file instanceof File;
    },
    onhashchangeHandler(ev) {
      const oldHash = ev.oldURL.split("#")[1] == undefined ? "" : ev.oldURL.split("#")[1];
      const newHash = ev.newURL.split("#")[1] == undefined ? "" : ev.newURL.split("#")[1];
      if (newHash.indexOf("department-") > -1 && oldHash.indexOf("slot-confirmed") > -1)
        this.back(false);
      else if (newHash == "" && oldHash.indexOf("department-") > -1) this.back(false);
      else if (oldHash == "appointment-request-sent") this.back(false);
    },
    getCustomStyle() {
      let data;
      if (this.companyDetails) {
        data = {
          company_id: this.company.id,
        };
      } else {
        data = {
          company_id: this.company.id,
          department_id: this.id,
        };
      }
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          if (res.data.data.header_text)
            $(".header-text").html(res.data.data.header_text);
          if (res.data.data.footer_text)
            $(".footer-text").html(res.data.data.footer_text);

          $(".card-body").css({
            "background-color": res.data.data.form_background_color,
          });
          $(
            "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span, span.e-input-group-icon.e-ddl-icon.e-search-icon"
          ).css({ color: res.data.data.form_text_color });
          $(".vfc-arrow-right, .vfc-arrow-left").css({
            "border-color": res.data.data.form_text_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          let css = {
            color: this.textColor.color,
            "border-bottom-color": this.textColor.color,
          };
          $(".e-control-wrapper").css(css);
          $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(this.textColor);
          this.textColor = {
            color: res.data.data.form_text_color + " !important",
          };
          this.font_size = {
            title: res.data.data.title_font_size,
            paragraph: res.data.data.paragraph_font_size,
          };

          $(".the-footer p, .the-footer a").css({
            color: res.data.data.form_text_color,
          });

          this.buttonCss = {
            "background-color": res.data.data.button_background_color + "!important",
            "border-color": res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color,
          };
          const rootCSSVars = document.querySelector(":root");
          rootCSSVars.style.setProperty(
            "--booking-form-button-bg",
            res.data.data.button_background_color
          );

          if (res.data.data.background_images)
            $("#content-area").css({
              "background-image": "url('" + res.data.data.background_images.path + "')",
              "background-position": "inherit",
              "background-repeat": "no-repeat",
              "background-size": "cover",
              "background-attachment": "fixed",
            });
          else $("#content-area").css({ "background-image": "none" });
        })
        .catch((error) => {
          this.logger("getCustomStyle", error);
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    changedMonth() {
      setTimeout(() => {
        $(
          "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span"
        ).css(this.textColor);
        $(".vfc-arrow-right, .vfc-arrow-left").css({
          "border-color": this.textColor,
        });
      }, 100);
    },

    checkValidation(arr, index) {
      if (arr == undefined) return false;
      if (arr.length) $("#input" + index).addClass("hide-check");
      if (arr == undefined || arr == "") {
        return true;
      }
      return false;
    },
    checkValidationRadio(arr, check) {
      if (check == 0 && !arr) {
        return false;
      }
      if (arr == undefined || arr == "") {
        return true;
      }
    },
    /**
     * get data
     */
    getQuestionFields(dep) {
      let data = {
        company_id: dep.company_id,
        department_id: dep.id,
      };
      this.$store
        .dispatch("GetQuestionFields", data)
        .then((res) => {
          if (res.data.data) {
            let multi = res.data.data.multi_form;
            this.multi_form = multi ? true : false;
            if (res.data.data.form_fields) {
              this.questionsFields = res.data.data.form_fields.filter((qf) => qf.shown);
              this.questionsFields.forEach((el, index) => {
                el.form = false;
                if (el.type == "checkbox") this.checkFields.push([index, el.required]);
                if (el.answer) {
                  const key = this.multi_form ? el.label : index;
                  if (el.type == "checkbox")
                    this.$set(this.selectedInput, `${key}`, el.answer.split(","));
                  else this.$set(this.selectedInput, `${key}`, el.answer);
                }
              });
            }
          }
        })
        .catch((error) => {
          this.logger("getQuestionFields", error);
          // Error response
          this.error = getErrorMessage(error, this);
          return false;
        });
    },

    /**
     * get company/department details
     */
    autoLogin(id) {
      this.show = true;
      //       // this.$vs.loading();
      let data = {
        id: id,
      };
      this.$store
        .dispatch("AutoLogin", data)
        .then((res) => {
          this.show = false;
          //this.$router.push("/" + this.cancelSlug).catch(() => {});
          this.$store.dispatch("staffOnlineIdsInit");
          this.success = this.$t("LoginSuccess");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            " src/frontend/BooAppointment.vue | Function : AutoLogin()",
            error
          );
          this.error = getErrorMessage(error, this);
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
    async checkAppointment(department_id, timeSlot, timeDate, timeZone) {
      console.log(
        `checkAppointment(${department_id}, ${timeSlot}, ${timeDate}, ${timeZone})`
      );
      this.firstDay = moment(timeDate, "DD/MM/YYYY").format("MM/DD/YYYY");
      this.dep_id = department_id;
      this.start_date = timeDate;
      this.timeZone = timeZone;
      await this.selectDpt(this.dep_id);
      this.selectTime.date = this.start_date;
      this.dateSel = this.selectTime;
      await this.getTimeSlots(this.dateSel);
      this.start_time = timeSlot.length > 5 ? timeSlot.substr(0, 5) : timeSlot;
    },

    checkSlots(index) {
      if (this.selected) return false;
      if (index != this.index) return false;

      if (index == this.index) {
        $(".confirm-button").hide();
        $("#slot-list>button").removeClass("isActive");
        $("#time-button-" + index).addClass("isActive");
        // $("#confirm-button-" + this.index).show();

        setTimeout(() => {
          $("#confirm-button-" + this.index).show();
          document.getElementById("confirm-button-" + this.index).scrollIntoView();
        }, 100);

        return true;
      }
    },
    //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },
    //validation error message
    errorClass(rule) {
      return {
        error: this.errors.firstByRule("password", rule),
      };
    },
    /**
     * Logout API call
     */
    handleLogout() {
      this.error = "";
      // Call store function
      this.$store
        .dispatch("Logout")
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          // Error response
          this.error = getErrorMessage(error, this);
          return false;
        });
    },
    /**
     * company details
     */
    async getCompanyDetails() {
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;
      this.profile_image = "loading";
      try {
        const res = await this.$store.dispatch("CompanyDetails", this.slug);
        this.show = false;
        if (res.data.status == "success") {
          this.company = res.data.data;
          this.website_url = res.data.data.website_url;
          this.getCustomStyle();

          this.errorMsg = false;
        } else {
          this.errorMsg = true;
        }
        this.profile_image = null;
        if (this.company.profile_image) this.profile_image = this.company.profile_image;
        console.log("Image", this.profile_image, this.header);
        // if (this.header) this.profile_image = this.defaults;
      } catch (error) {
        this.logger(arguments.callee.name, error);
        this.error = getErrorMessage(error, this);
        this.show = false;
        this.errorMsg = true;
      }
    },
    /**
     * leaveStaff method
     */
    leaveStaff(id, value) {
      var data = {
        staff_id: id,
        is_loggedin: value,
      };
      this.$store
        .dispatch("LeaveStaff", data)
        .then((res) => {
          this.checkStartMeeting(this.id);
        })
        .catch((error) => {
          this.error = getErrorMessage(error, this);
          return false;
        });
    },
    /**
     * on department selection
     */

    async selectDpt(id) {
      if (this.company.departments) {
        const department = this.company.departments.find((dp) => dp.id == id);
        if (department)
          window.location.hash = parseStringToURLFriendly(
            `department ${department.slug}`
          );
      } else window.location.hash = parseStringToURLFriendly(`department ${id}`);

      this.id = id;
      await this.getDepartmentDetails();
      await this.checkStartMeeting(id);
      this.companyDetails = false;
      this.getCustomStyle();

      this.currentDate = moment(new Date(), "D/M/YYYY").format("D/M/YYYY");
      this.endDate = moment(new Date(), "MM/DD/YYYY").add(1, "M").endOf("month");
      this.nextMonthStartDate = moment(new Date(), "MM/DD/YYYY")
        .add(1, "M")
        .startOf("month");
      this.endDate = this.endDate.format("D/M/YYYY");
      if (this.$store.getters.currentUser) {
        this.scheduleEvent = { ...this.$store.getters.currentUser };
        let index = this.documentTypeArray.findIndex(
          (element) => element.code == this.scheduleEvent.type
        );
        this.scheduleEvent.type = this.documentTypeArray[index];
        if (this.scheduleEvent.identity_document != null) {
          if (this.scheduleEvent.identity_document.path.includes(".pdf")) {
            this.url = require("@/assets/images/portrait/small/default_pdf.png");
          } else this.url = this.scheduleEvent.identity_document.path;
        } else this.url = require("@/assets/images/portrait/small/default_upload.png");
      }
      this.loadLocale(this.$i18n.locale);
      this.walkinDepartmentChannelInit();
    },
    async walkinDepartmentChannelInit() {
      channels.walkinDepartment.forEach((channel) => {
        window.Echo.leave(channel);
        // leave previous subscribed channels
      });
      channels.walkinDepartment = []; // reset

      const onlineDepartment = `department-online-${this.id}`;
      channels.walkinDepartment.push(onlineDepartment);

      window.Echo.join(onlineDepartment)
        .here((ids) => {
          this.availableStaffIds = ids.filter((id) => typeof id == "number");
          // this.checkStartMeeting(this.id);
        })
        .joining((staffId) => {
          if (typeof staffId == "number") {
            this.availableStaffIds.push(staffId);
            // this.checkStartMeeting(this.id);
          }
        })
        .leaving((staffId) => {
          if (typeof staffId == "number") {
            this.availableStaffIds = this.availableStaffIds.filter((id) => id != staffId);
            // this.checkStartMeeting(this.id);
          }
        });
      // .listen(
      //   "WalkinOnOffToggle",
      //   (res) => {
      //     if (this.id) {
      //       console.log(res.data);
      //       if(res.data.walkin == 1){
      //         this.department.availableStaffIds.push(res.data.staff_id);
      //       }else{
      //         this.department.availableStaffIds = this.department.availableStaffIds.filter(staffId => staffId != res.data.staff_id);
      //       }
      //       this.checkStartMeeting(this.id)
      //     };
      //   }
      // );
    },
    /**
     * validate phone number
     */
    onInput({ number, isValid, country }) {
      this.scheduleEvent.contact_number = number["international"];
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     * append country code
     */
    appendCode() {
      if (this.scheduleEvent.contact_number.includes("+") == false) {
        this.scheduleEvent.contact_number =
          this.country + " " + this.scheduleEvent.contact_number;
      }
    },
    /**
     * Country Code
     */
    countryChanged(country) {
      this.country = "+" + country.dialCode;
    },
    /**
     * show calender
     */
    backToCalender() {
      $(".time-selection").removeClass("date-selected");
      $(".timeslot").addClass("hideslots");
      this.index = "NA";
    },
    checkBox() {
      this.checkFields.map((el, index) => {
        if (el[1]) {
          if (!this.selectedInput[el[0]] || this.selectedInput[el[0]] == undefined)
            $("#input" + el[0]).removeClass("hide-check");
          else $("#input" + el[0]).addClass("hide-check");
        }
      });
      return true;
    },
    /**
     * schedule event/appointment
     */
    schedule: debounce(async function (form) {
      this.show = true;
      if (form != "login") delete this.scheduleEvent.password;

      this.checkBox();

      const isValidate = await this.$validator.validateAll(form);
      if (!isValidate) return (this.show = false);
      this.isLogin = false;
      this.success = "";
      this.error = "";
      // this.$vs.loading();

      moment.locale("en");

      const scheduleEvent = { ...this.scheduleEvent };
      const fd = new FormData();
      fd.append("company_id", this.department.company_id);
      scheduleEvent.language = this.$i18n.locale;
      if (scheduleEvent.gender) scheduleEvent.gender = scheduleEvent.gender.toLowerCase();

      scheduleEvent.document =
        scheduleEvent.type != null && scheduleEvent.type != undefined
          ? scheduleEvent.type.code
          : null;

      scheduleEvent.document_path = null;
      if (this.images) scheduleEvent.document_path = this.images ? this.images : null;

      scheduleEvent.is_unio = 0;
      scheduleEvent.timezone = this.timeZone;
      scheduleEvent.is_booked_by_inmate = 0;

      if (this.reschedule) {
        scheduleEvent.appointment_details = {};
        scheduleEvent.appointment_details.is_rescheduled = 1;
        scheduleEvent.appointment_details.rescheduled_id = this.cancelAppId;
      }

      for (let key in scheduleEvent) {
        if (key == "dob") {
          if (scheduleEvent[key] && scheduleEvent[key].length == 10)
            fd.append(key, scheduleEvent[key]);
          else if (
            scheduleEvent[key] &&
            typeof scheduleEvent[key].toISOString == "function"
          )
            fd.append(key, scheduleEvent[key].toISOString());
          else fd.append(key, "");
        } else if (key == "profile_image") {
          fd.append(key, JSON.stringify(scheduleEvent[key] || ""));
        } else fd.append(key, scheduleEvent[key] || "");
      }

      let appointment_details = {
        guest_emails: this.guestEmails.map((e) => e.text).join(),
        company_id: this.department.company_id,
        start_datetime: this.selectedTime.start_datetime,
        end_datetime: this.selectedTime.end_datetime,
        department_id: this.id,
        type: this.type,
        is_rescheduled: this.isReschedule
          ? "1"
          : this.cookie_appointment_id != null
          ? "1"
          : "0",
        rescheduled_id:
          this.cookie_appointment_id != null ? this.cookie_appointment_id : "",
      };
      if (this.reschedule) {
        appointment_details.is_rescheduled = 1;
        appointment_details.rescheduled_id = this.cancelAppId;
      }
      fd.append(`appointment_details`, JSON.stringify(appointment_details));
      // this.show = false;
      this.questionsFields.forEach((qf, i) => {
        const fk = `question_option_field[${i}]`;
        fd.append(`${fk}[type]`, qf.type == "files" ? "file" : qf.type);
        fd.append(`${fk}[question]`, qf.label);

        let valueOption = this.selectedInput[qf.label] || this.selectedInput[i] || "";
        if (["checkbox", "input", "text-area", "radio"].indexOf(qf.type) > -1) {
          console.log("valueOption", valueOption);
          console.log("qf", qf);
          if (Array.isArray(valueOption)) valueOption = valueOption.join();
          else if (typeof valueOption != "string") valueOption = "";
          fd.append(`${fk}[answer]`, valueOption);
        } else if (qf.type == "files") {
          for (let docName in valueOption) {
            fd.append(`${fk}[answer][${docName}]`, valueOption[docName] || "");
          }
        }
      });

      const idocname = this.documentTypeArray.find(
        (dt) => dt.code == scheduleEvent.document
      );
      if (idocname && scheduleEvent.document_path) {
        const fk = `question_option_field[${this.questionsFields.length}]`;
        fd.append(`${fk}[type]`, "file");
        fd.append(`${fk}[question]`, "Identity Document");
        fd.append(`${fk}[answer][${idocname._label}]`, scheduleEvent.document_path);
      }

      // return false;

      try {
        const res = await this.$store.dispatch("ScheduleEvent", fd);
        this.isLogin = false;
        if (res.data.status == "warning")
          this.error = getErrorMessage(res.data.message, this);
        else this.scheduleResponseHandler(res);
      } catch (error) {
        this.logger("schedule", error);
        // Error response
        this.error = getErrorMessage(error, this);
      }
      this.show = false;
    }, 250),

    scheduleResponseHandler(res) {
      this.userdata = res.data.data;
      console.log();
      if (
        this.$store.getters.currentUser.user_role == "user" ||
        this.$store.getters.currentUser.user_role == undefined
      ) {
        if (res.data.data && this.$store.state.auth.token != null) {
          this.$store.commit("SET_USER", {
            ...this.$store.state.auth.currentUser,
            ...res.data.data,
          });
        }

        if (res.data.token == null && this.scheduleEvent.id == undefined) {
          this.autoLogin(res.data.encrypt_user_id);
        }
      }

      if (res.data.appointment_details !== null) {
        this.appointmentDetails = res.data.appointment_details;
        if (this.type == "walkin") {
          this.startConf();
          return false;
        }
        if (this.appointmentDetails.is_premium) {
          this.isPremiumMeeting = true;
          this.appointmentDetails.currency = this.appointmentDetails.currency.toUpperCase();
          this.loadIntent();
        }
        // else{
        //   this.isPremiumMeeting = false;
        // }
      }
      this.showConfirmation = true;
      this.show = false;
      window.location.hash = "appointment-request-sent";
      // Success response
      if (this.appointmentDetails.is_booked != true) {
        this.success = this.$t("EventScheduled");
        this.$toasted.show(this.success, {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      }

      if (
        res.data.appointment_details.is_premium == 1 &&
        res.data.appointment_details.payment_status == 1
      ) {
        this.paymentDone = true;
      }
      //Reschedule Appointment
      if (this.isReschedule && res.data.appointment_details.is_rescheduled == 1) {
        this.paymentDone = true;

        var data = {
          appointment_id: res.data.appointment_details.id,
          is_missed_call: 0,
        };
        this.$store
          .dispatch("UpdateMissedCallFlag", data)
          .then((res) => {
            this.updateMissedCallFlag = false;
          })
          .catch((error) => {
            this.error = getErrorMessage(error, this);
            return false;
          });
      }
      Cookies.remove("appointment_id_reschedule");
    },

    /**
     * get company/department details
     */
    cancelMeeting() {
      this.$swal({
        title: this.$t("CancelMeetingAlert"),

        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      })
        .then((result) => {
          if (result.value) {
            this.success = "";
            this.error = "";
            let id = this.cancelAppId;
            if (id) {
              this.cancelApp(id);
            } else return false;
          }
        })
        .catch((error) => {
          this.$log.error(" List.vue | Function : deleteStaff()", error);
          this.show = false;
          // Error response
          this.error = getErrorMessage(error, this);
          return false;
        });
    },
    cancelApp(id) {
      // this.$vs.loading();
      let data = {
        cancel_by_user: true,
        id: id,
      };
      this.show = true;
      this.$store
        .dispatch("CancelMeeting", data)
        .then((res) => {
          this.show = false;
          this.cancel = "";
          //this.$router.push("/" + this.cancelSlug).catch(() => {});
          this.success = this.$t("CancelMeetingMessage");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
          setTimeout(this.redirect, 1000);
        })
        .catch((error) => {
          this.$log.error(
            " src/frontend/BooAppointment.vue | Function : cancelMeeting()",
            error
          );
          this.error = getErrorMessage(error, this);
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
    redirect() {
      location.href = "/" + this.cancelSlug;
    },

    /*
    Loads the payment intent key for the user to pay.
    */
    checkCancelAppointment() {
      this.decodeCancel = window.atob(this.cancel);

      let [
        appointment_id,
        department_id,
        timeSlot,
        timeDate,
        timeZone,
        user_id,
      ] = this.decodeCancel.split("&");

      this.cancelAppId = appointment_id || "";

      let data = { id: appointment_id };
      this.show = false;
      this.$store
        .dispatch("CancelAppointmentStatus", data)
        .then((res) => {
          this.show = true;
          this.highlightDate = timeDate;
          this.checkAppointment(department_id, timeSlot, timeDate, timeZone);
        })
        .catch((error) => {
          this.$log.error(
            " src/frontend/BooAppointment.vue | Function : checkCancelAppointment()",
            error
          );
          this.error = getErrorMessage(error, this);
          this.show = false;
          this.alreadyCancelMsg = this.$t("AlreadyCancelMeetingMessage");
          console.log(this.alreadyCancelMsg);
          this.errorMsg = true;
          return false;
        });
    },

    /**
     * show gust textarea
     */
    addguest() {
      this.isGuestAdd = true;
    },
    /**
     * when time slot selected
     */
    timeSlotSelected(index) {
      // $(".confirm-button").hide();
      // $("#slot-list>button").removeClass("isActive");
      // $("#time-button-" + index).addClass("isActive");
      this.start_time = this.slots[index].start_time;
      // $("#confirm-button-" + index).show();
    },
    /**
     * when click on confirm button
     */
    confirm(slot, index) {
      window.location.hash = parseStringToURLFriendly(
        `slot confirmed ${slot.start_time} ${slot.end_time}`
      );
      this.showConfirm = true;
      this.showTimeSlots = false;
      this.col = "lg:w-1/2 xl:w-1/2";

      this.selectedTime = slot;
      this.timeIndex = index;
      this.hide = true;
      this.type = "normal";
      this.backToCalender();
    },

    /**
     * when click on confirm button
     */
    confirmMeeting() {
      this.showConfirm = true;
      this.startMeet = true;
      this.showTimeSlots = false;
      this.type = "walkin";
      this.col = "lg:w-1/2 xl:w-1/2";
      var today = moment();
      this.slectedDate = moment(today, "D/M/YYYY").format("dddd, MMMM D, YYYY");
      var endDate = moment().add(this.department.duration, "m").toDate();
      this.currentSelectedDate = moment(today, "D/M/YYYY").format("dddd, MMMM D, YYYY");

      var startDate = moment().format("LT");
      var endDate = moment(endDate).format("LT");

      var slot = {
        start_time: startDate,
        end_time: endDate,
      };
      this.selectedTime = slot;
      this.hide = true;
      this.backToCalender();
    },
    /**
     * back to company page
     */
    back(historyBack = true) {
      if (historyBack) {
        window.history.back();
        return false;
      }

      if (this.cancelSlug) {
        location.href = "/" + this.cancelSlug;
        return false;
      }
      if (!this.showConfirm) {
        this.formFields = [];
        this.questionsFields = [];
        this.companyDetails = true;
        this.showConfirm = false;
        this.startMeet = false;
        this.showTimeSlots = false;
        this.col = "lg:w-1/2 xl:w-1/2";
        this.department = [];
        this.dateMarked = [];
        this.slots_availablity = [];
        this.disabledDates = [];
        this.showConfirmation = false;
        this.isLogin = false;
        this.hide = this.staffSlug ? false : true;
        this.getCustomStyle();
        this.isPremiumMeeting = false;
        this.showLoginForm = false;
        this.paymentDone = false;
        this.showPayForm = false;
        $(".vfc-arrow-left").click();
      } else {
        this.showConfirm = false;

        if (this.startMeet) {
          this.showTimeSlots = false;
        } else {
          this.showTimeSlots = true;
          this.col = "lg:w-1/3 xl:w-1/3";
          this.hide = this.staffSlug ? false : true;
          this.getCustomStyle();
        }
        this.startMeet = false;
        this.paymentDone = false;
        this.showPayForm = false;
        $(".vfc-arrow-left").click();
        setTimeout(() => {
          $("#time-button-" + this.timeIndex).addClass("isActive");
          $("#confirm-button-" + this.timeIndex).show();
          $(".time-selection").addClass("date-selected");
          $(".timeslot").removeClass("hideslots");
        }, 100);
      }
      this.getCustomStyle();
    },

    /**
     * get company/department details
     */
    async getDepartmentDetails() {
      //this.getCustomStyle();
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;
      try {
        const res = await this.$store.dispatch("DepartmentDetails", {
          id: this.id,
          params: { timezone: this.timeZone },
        });
        this.show = false;
        this.slotMsg = false;
        if (res.data.status == "success") {
          // this.disabledDates = res.data.data.disabled_dates
          // .map(dd => moment(dd, 'YYYY-MM-DD').format('DD/MM/YYYY'));
          this.department = res.data.data;
          date_slots = res.data.date_slots;
          this.company.id = this.department.company_id;
          this.getCustomStyle();
          this.header = this.$store.getters.header;
          if (this.department.company_profile_image) {
            this.profile_image = this.department.company_profile_image;
          }

          moment.locale("en");

          this.department.disabled_dates.forEach((element) => {
            this.disabledDates.push(moment(element, "YYYY-MM-DD").format("YYYY-MM-DD"));
          });

          this.department.slots_availablity.forEach((element) => {
            this.getDatesByDay(moment(), element.day);
            this.getDatesByDay(this.nextMonthStartDate, element.day);
          });

          //custome time solts
          this.department.custom_slots_availablity.forEach((element) => {
            if (this.disabledDates.includes(element.day) == false) {
              this.dateMarked.push(moment(element.day, "YYYY-MM-DD").format("D/M/YYYY"));
              this.slots_availablity.push({
                date: moment(element.day, "YYYY-MM-DD").format("D/M/YYYY"),
                class: "marked-class",
              });
            }
          });

          this.getDisabledDates();

          if (
            this.department.slots_availablity.length <= 0 &&
            this.department.custom_slots_availablity.length <= 0
          ) {
            this.slotMsg = true;
          }

          this.errorMsg = false;
          this.getFields(this.department.company_id);
          this.getQuestionFields(this.department);
        } else {
          this.errorMsg = true;
        }
        let temp = this.slots_availablity;
        this.slots_availablity.forEach((el, index) => {
          let date = moment(this.highlightDate, "D/M/YYYY").format("D/M/YYYY");
          if (el.date == date) {
            let dark = "vfc-marked vfc-hover vfc-borderd";
            el.class = dark;
          }
        });
        // if (this.header) this.profile_image = this.defaults;
      } catch (error) {
        console.error(error);
        this.$log.error(
          " src/frontend/BooAppointment.vue | Function : getCompanyDetails()",
          error
        );
        this.error = getErrorMessage(error, this);
        this.show = false;
        this.errorMsg = true;
      }
    },

    /**
     * get company/department details
     */
    async getDepartmentDetailsBySlug() {
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;

      this.currentDate = moment(new Date(), "D/M/YYYY").format("D/M/YYYY");
      this.endDate = moment(new Date(), "MM/DD/YYYY").add(1, "M").endOf("month");
      this.nextMonthStartDate = moment(new Date(), "MM/DD/YYYY")
        .add(1, "M")
        .startOf("month");
      this.endDate = this.endDate.format("D/M/YYYY");
      if (this.$store.getters.currentUser) {
        this.scheduleEvent = { ...this.$store.getters.currentUser };
        let index = this.documentTypeArray.findIndex(
          (element) => element.code == this.scheduleEvent.type
        );
        this.scheduleEvent.type = this.documentTypeArray[index];
        if (this.scheduleEvent.identity_document != null) {
          if (this.scheduleEvent.identity_document.path.includes(".pdf")) {
            this.url = require("@/assets/images/portrait/small/default_pdf.png");
          } else this.url = this.scheduleEvent.identity_document.path;
        } else this.url = require("@/assets/images/portrait/small/default_upload.png");
        if (this.scheduleEvent.id == undefined && this.isReschedule) {
          this.showLoginForm = true;
        }
      }
      let data = {
        staffSlug: this.staffSlug,
        company_slug: this.slug,
        params: {
          timezone: this.timeZone,
        },
      };
      try {
        const res = await this.$store.dispatch("DepartmentDetailsBySlug", data);
        this.show = false;
        this.slotMsg = false;
        this.hide = false;

        if (res.data.status == "success") {
          this.department = res.data.data;
          date_slots = res.data.date_slots;
          this.website_url = res.data.data.website_url;
          this.id = this.department.id;
          this.company.id = this.department.company_id;
          if (this.department.company_profile_image) {
            this.profile_image = this.department.company_profile_image;
          }

          moment.locale("en");

          this.department.disabled_dates.forEach((element) => {
            this.disabledDates.push(moment(element, "YYYY-MM-DD").format("YYYY-MM-DD"));
          });

          this.department.slots_availablity.forEach((element) => {
            this.getDatesByDay(moment(), element.day);
            this.getDatesByDay(this.nextMonthStartDate, element.day);
          });

          //custome time solts
          this.department.custom_slots_availablity.forEach((element) => {
            if (this.disabledDates.includes(element.day) == false) {
              this.dateMarked.push(moment(element.day, "YYYY-MM-DD").format("D/M/YYYY"));
              this.slots_availablity.push({
                date: moment(element.day, "YYYY-MM-DD").format("D/M/YYYY"),
                class: "marked-class",
              });
            }
          });

          this.getDisabledDates();

          if (
            this.department.slots_availablity.length <= 0 &&
            this.department.custom_slots_availablity.length <= 0
          ) {
            this.slotMsg = true;
          }

          this.errorMsg = false;
          this.companyDetails = false;
          this.getFields(this.department.company_id);
          this.getQuestionFields(this.department);
          this.walkinDepartmentChannelInit();
        } else {
          this.errorMsg = true;
        }

        if (res.data.data.department_id)
          this.checkStartMeeting(res.data.data.department_id);

        this.getCustomStyle();
        // if (this.header) this.profile_image = this.defaults;
      } catch (error) {
        this.$log.error(
          " src/frontend/BooAppointment.vue | Function : getCompanyDetails()",
          error
        );
        this.error = getErrorMessage(error, this);
        this.show = false;
        this.errorMsg = true;
      }
    },

    /**
     *  getstaffs method get all companies from company list
     **/

    async getTimeZones() {
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;

      this.$store
        .dispatch("GetTimeZone")
        .then((res) => {
          this.show = false;
          this.options = res.data.data;
          //   if (res.data.data != null) this.staffs = res.data.data;
        })
        .catch((error) => {
          this.$log.error(
            "src/frontend/BookAppointment.vue | Function : getTimeZones()",
            error
          );
          this.error = getErrorMessage(error, this);
          this.show = false;
          this.error = getErrorMessage(error, this);
          return false;
        });
    },
    /**
     * dates by day
     */
    getDatesByDay(date, day) {
      var monday = moment(date).startOf("month").day(day);
      if (monday.date() > 7) monday.add(7, "d");
      var month = monday.month();
      let light = "marked-class";
      let dark = "vfc-marked vfc-hover vfc-borderd";
      let slotDate = monday.format("DD-MM-YYYY");
      let check = slotDate == this.currentDate ? dark : light;
      while (month === monday.month()) {
        // if time slot available
        if (this.disabledDates.includes(monday.format("YYYY-MM-DD")) == false) {
          if (moment().diff(monday.format("YYYY-MM-DD")) <= 0) {
            this.dateMarked.push(monday.format("D/M/YYYY"));

            this.slots_availablity.push({
              date: monday.format("D/M/YYYY"),
              class: check,
            });

            // return;
          } else if (
            moment(date, "YYYY-MM-DD").format("YYYY-MM-DD") == monday.format("YYYY-MM-DD")
          ) {
            this.dateMarked.push(monday.format("D/M/YYYY"));
            this.slots_availablity.push({
              date: monday.format("D/M/YYYY"),
              class: check,
            });
          }
        }
        monday.add(7, "d");
      }
    },
    /**
     * get slots
     */
    async getTimeSlots(event) {
      if (!event.hide) this.selected = true;
      moment.locale("en");
      this.dateSel = event;
      if (this.dateMarked.includes(event.date) || this.id || this.dep_id) {
        var day = moment(event.date, "D/M/YYYY").format("dddd");
        // console.log('event.date', event.date);
        this.currentSelectedDate = moment(event.date, "D/M/YYYY").format(
          "dddd, MMMM D, YYYY"
        );
        this.selectedCurrentDate = event.date;
        moment.locale(this.$i18n.locale);
        this.slectedDate = moment(event.date, "D/M/YYYY").format("dddd, MMMM D, YYYY");
        day = day.toLowerCase();
        const data = {
          day: day,
          id: this.id || this.dep_id,
          date: moment(event.date, "D/M/YYYY").format("YYYY-MM-DD"),
          timezone: this.timeZone,
        };

        this.slots = [];
        this.success = "";
        this.error = "";
        // this.$vs.loading();
        this.show = true;
        try {
          // Comment below code to reduce the api call and retrieved from already stored data
          // const res = await this.$store.dispatch("GetDaySlots", data);
          // this.slots = res.data.data.slots;
          this.slots = date_slots[data.date] !== undefined ? date_slots[data.date] : [];
          this.col = "lg:w-1/3 xl:w-1/3";
          this.showTimeSlots = true;
          let time = moment(this.start_time, "hhmmss").format("hh:mm A");
          this.index = this.slots.findIndex((el) => el.start_time == time);
          $(".time-selection").addClass("date-selected");
          $(".timeslot").removeClass("hideslots");
          moment.locale("en");
          setTimeout(() => {
            let css = {
              color: this.textColor.color,
              "border-bottom-color": this.textColor.color,
            };
            $(".e-control-wrapper").css(css);
            $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(this.textColor);
          }, 100);
        } catch (error) {
          console.log(error);
          this.$log.error(
            "src/frontend/BookAppointment.vue | Function : getTimeSlots()",
            error
          );
          this.error = getErrorMessage(error, this);
        }
        this.show = false;
      } else {
        return false;
      }
    },

    /**
     * dispabled dates
     */
    getDisabledDates() {
      var startDate = moment();
      var endDate = moment(new Date(), "MM/DD/YYYY").add(1, "M").endOf("month");
      endDate = endDate.format("YYYY-MM-DD");
      while (startDate.isSameOrBefore(endDate, "day")) {
        if (!this.dateMarked.includes(startDate.format("D/M/YYYY"))) {
          if (!this.disabledDates.includes(startDate.format("YYYY-MM-DD"))) {
            let arr = {
              date: startDate.format("D/M/YYYY"),
              class: "marked-class",
            };
            this.slots_availablity.push(arr);
          } else {
            this.disabledDates.push(startDate.format("D/M/YYYY"));
          }
        }

        startDate.add(1, "days");
      }
    },

    /**
     * show payment form
     */
    payForm() {
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;
      this.showPayForm = true;
      this.includeStripe(
        "js.stripe.com/v3/",
        function () {
          this.configureStripe();
        }.bind(this)
      );
    },
    /*
      Includes Stripe.js dynamically
    */
    includeStripe(URL, callback) {
      var documentTag = document,
        tag = "script",
        object = documentTag.createElement(tag),
        scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = "//" + URL;
      if (callback) {
        object.addEventListener(
          "load",
          function (e) {
            callback(null, e);
          },
          false
        );
      }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    /*
        Configures Stripe by setting up the elements and
        creating the card element.
    */
    configureStripe() {
      this.stripe = Stripe(this.stripeAPIToken);
      this.elements = this.stripe.elements();
      this.card = this.elements.create("card", {
        iconStyle: "solid",
        style: {
          base: {
            iconColor: "#ccc",
            color: "#626262",
            fontWeight: 100,
            fontFamily: '"Montserrat", Helvetica, Arial, sans-serif',
            fontSize: "14px",
            "::placeholder": {
              color: "#ccc",
            },
          },
          invalid: {
            iconColor: "#e85746",
            color: "#e85746",
          },
        },
      });
      this.card.mount("#card-element");
      this.card.on("change", ({ error }) => {
        if (error) {
          this.stripValidationError = error.message;
        } else {
          this.stripValidationError = "";
        }
      });
      this.show = false;
    },
    /*
    Loads the payment intent key for the user to pay.
    */
    loadIntent() {
      if (this.appointmentDetails) {
        this.$store
          .dispatch("LoadIntent", this.appointmentDetails.id)
          .then((res) => {
            this.intentToken = res.data.data;
          })
          .catch((error) => {
            this.$log.error(
              "src/frontend/BookAppointment.vue | Function : loadIntent()",
              error
            );
            this.error = getErrorMessage(error, this);
            return false;
          });
      }
    },

    /*
    Loads the payment intent key for the user to pay.
    */
    async checkStartMeeting(id) {
      try {
        if (this.department.availableStaffIds == undefined) return;
        // const res = await this.$store.dispatch("CheckStartMeeting", id)
        // this.startMeeting = res.data.data;
        const availableStaffIds = [...this.department.availableStaffIds];
        const available_staffs = this.department.available_staffs;
        this.startMeeting = { availableStaffIds, available_staffs };

        if (this.availableStaffIds) {
          const filteredArray = this.availableStaffIds.filter((value) =>
            this.startMeeting.availableStaffIds.includes(value)
          );
          this.startMeeting.available_staffs = filteredArray.length > 0 ? true : false;
        } else this.startMeeting.available_staffs = false;
        setTimeout(() => {
          this.getStaffAvailableSlot();
        }, 500);
      } catch (error) {
        console.error(error);
        this.$log.error(
          `src/frontend/BookAppointment.vue | Function : checkStartMeeting(${id})`,
          error
        );
        this.error = getErrorMessage(error, this);
      }
    },
    /**
     * submit payment
     */
    submitPaymentMethod() {
      console.log(this.intentToken.client_secret);
      console.log(this.stripValidationError);
      if (this.intentToken.client_secret && this.stripValidationError == "") {
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.payDisabled = true;
            this.show = true;
            this.stripe
              .confirmCardPayment(this.intentToken.client_secret, {
                payment_method: {
                  card: this.card,
                  billing_details: {
                    name: this.cardHolderName,
                  },
                },
              })
              .then(
                function (result) {
                  if (result.error) {
                    if (this.stripValidationError == "")
                      this.stripErrors = result.error.message;
                    this.payDisabled = false;
                    if (result.paymentIntent) {
                      var data = {
                        id: result.paymentIntent.id,
                        appointment_id: this.appointmentDetails.id,
                        status: "failed",
                      };
                      this.savePayment(data, "failed");
                    }
                  } else {
                    if (result.paymentIntent.status == "succeeded") {
                      var data = {
                        id: result.paymentIntent.id,
                        appointment_id: this.appointmentDetails.id,
                        status: result.paymentIntent.status,
                      };
                      this.savePayment(data, "succeeded");
                    }
                  }
                  this.show = false;
                }.bind(this)
              );
          }
        });
      }
    },

    /**
     * Save Payment Details
     */
    savePayment(data, status) {
      this.$store
        .dispatch("SavePaymentDetails", data)
        .then((res) => {
          if (status == "succeeded") {
            this.paymentDone = true;
            this.payDisabled = false;
          }
        })
        .catch((error) => {
          this.$log.error(
            "src/frontend/BookAppointment.vue | Function : savePayment()",
            error
          );
          this.error = getErrorMessage(error, this);
          return false;
        });
    },
    /**
     * get data
     */
    getFields(id) {
      this.$store
        .dispatch("GetFields", id)
        .then((res) => {
          if (res.data.data.form_fields) {
            let formFields = res.data.data.form_fields;
            console.log("formFields", formFields);

            console.log("before----", this.scheduleEvent);
            for (let key in this.scheduleEvent) {
              if (key == "identity_document" && !formFields[key]) {
                console.log(key);
                delete this.scheduleEvent[key];
              }
            }
            console.log("after----", this.scheduleEvent);

            for (let key in formFields) {
              formFields[key].form = true;
              if (this.scheduleEvent[key]) delete formFields[key];
            }

            this.formFields = formFields;
          }
        })
        .catch((error) => {
          this.$log.error("src/frontend/BookingForm.vue | Function : getFields()", error);
          this.error = getErrorMessage(error, this);
          return false;
        });
    },

    unsetFile(idx, label) {
      if (this.selectedInput[idx][label]) {
        this.$set(this.selectedInput[idx], label, null);
      }
      this.image = "";
      this.imageObject = "";
      if (this.$refs[label] && this.$refs[label][0]) this.$refs[label][0].value = "";
    },
    setFiles(idx, label, file, from = "") {
      if (from == "") {
        if (!this.selectedInput[idx]) this.$set(this.selectedInput, idx, {});

        const selectedFiles = file;

        if (selectedFiles.length < 1) return;
        console.log(label, selectedFiles);
        this.$set(this.selectedInput[idx], label, selectedFiles);
        this.image = file;
        console.log("image", this.image);

        let id = `${label}-${idx}`;
        const firstPart = id.split("-")[0];
        this.arr.push(firstPart);
      } else {
        this.imageObject = file;
        this.image = file;
        this.indexFile = `${label}-${idx}`;
        const firstPart = `${label}-${idx}`.split("-")[0];
        this.arr.push(firstPart);
      }
    },
    selectedFile(file) {
      this.images = file;
      // if (this.images.type == "application/pdf")
      //   this.url = require("@/assets/images/portrait/small/default_pdf.png");
      // else this.url = URL.createObjectURL(this.images);
      this.imageObject = file;
    },
    /**
     * Start conference
     */
    startConf() {
      location.href = this.appointmentDetails.conference_link;
    },

    getStaffAvailableSlot() {
      const filteredArray = this.availableStaffIds.filter((value) =>
        this.startMeeting.availableStaffIds.includes(value)
      );
      var data = {
        department_id: this.id,
        timezone: this.timeZone,
        staff_ids: filteredArray,
      };
      this.$store
        .dispatch("getStaffAvailableSlot", data)
        .then((res) => {
          this.showWalkin = res.data.data.is_staff_Available;
        })
        .catch((error) => {
          // Error response
          this.error = getErrorMessage(error, this);
          return false;
        });
    },

    redirectToWebsiteUrl() {
      if (this.website_url) {
        window.open(this.website_url, "_blank");
      }
    },
  },
};
</script>
<style>
@import "./BookAppointment.css";
</style>
<style scoped lang="scss">
$bg-company: var(--booking-form-button-bg);
.booking-form-btn:focus {
  outline: 2px solid $bg-company;
  outline-offset: 2px;
}

.vue-tel-input:focus-within {
  box-shadow: 0 0 10px $bg-company !important;
  border: 1px solid $bg-company !important;
}

/deep/ {
  input.form-control:focus,
  .form-control:focus,
  .form-control.b-form-datepicker:focus-within {
    border: 1px solid $bg-company !important;
    box-shadow: 0 0 10px $bg-company !important;
  }
  .vs__dropdown-option--highlight,
  .vs__dropdown-option--selected,
  .vs__selected-options .vs__selected {
    background: $bg-company !important;
  }
}
.vue-tags-input /deep/ .ti-new-tag-input {
  border-radius: 0.3rem;
  display: block;
  padding: 0.6rem;
}
.vue-tags-input {
  background-color: rgba(255, 255, 255, 0.5);
  max-width: 100% !important;
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";

$bg-company: var(--booking-form-button-bg);
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: $bg-company;
  background-color: $bg-company;
}
.avatar-default .b-avatar-img img {
  border-radius: initial !important;
  width: 72px !important;
  height: 36px !important;
}
</style>
